function Un(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Rs } = Object.prototype, { getPrototypeOf: Ht } = Object, Ke = ((e) => (t) => {
  const n = Rs.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Q = (e) => (e = e.toLowerCase(), (t) => Ke(t) === e), Je = (e) => (t) => typeof t === e, { isArray: Te } = Array, ve = Je("undefined");
function vs(e) {
  return e !== null && !ve(e) && e.constructor !== null && !ve(e.constructor) && j(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Hn = Q("ArrayBuffer");
function Os(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Hn(e.buffer), t;
}
const Cs = Je("string"), j = Je("function"), zn = Je("number"), Ye = (e) => e !== null && typeof e == "object", Ls = (e) => e === !0 || e === !1, Be = (e) => {
  if (Ke(e) !== "object")
    return !1;
  const t = Ht(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Is = Q("Date"), Ds = Q("File"), Ns = Q("Blob"), Ps = Q("FileList"), Ms = (e) => Ye(e) && j(e.pipe), xs = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || j(e.append) && ((t = Ke(e)) === "formdata" || // detect form-data instance
  t === "object" && j(e.toString) && e.toString() === "[object FormData]"));
}, Fs = Q("URLSearchParams"), Us = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Oe(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let s, o;
  if (typeof e != "object" && (e = [e]), Te(e))
    for (s = 0, o = e.length; s < o; s++)
      t.call(null, e[s], s, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), r = i.length;
    let u;
    for (s = 0; s < r; s++)
      u = i[s], t.call(null, e[u], u, e);
  }
}
function $n(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let s = n.length, o;
  for (; s-- > 0; )
    if (o = n[s], t === o.toLowerCase())
      return o;
  return null;
}
const Bn = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), jn = (e) => !ve(e) && e !== Bn;
function Dt() {
  const { caseless: e } = jn(this) && this || {}, t = {}, n = (s, o) => {
    const i = e && $n(t, o) || o;
    Be(t[i]) && Be(s) ? t[i] = Dt(t[i], s) : Be(s) ? t[i] = Dt({}, s) : Te(s) ? t[i] = s.slice() : t[i] = s;
  };
  for (let s = 0, o = arguments.length; s < o; s++)
    arguments[s] && Oe(arguments[s], n);
  return t;
}
const Hs = (e, t, n, { allOwnKeys: s } = {}) => (Oe(t, (o, i) => {
  n && j(o) ? e[i] = Un(o, n) : e[i] = o;
}, { allOwnKeys: s }), e), zs = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), $s = (e, t, n, s) => {
  e.prototype = Object.create(t.prototype, s), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Bs = (e, t, n, s) => {
  let o, i, r;
  const u = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      r = o[i], (!s || s(r, e, t)) && !u[r] && (t[r] = e[r], u[r] = !0);
    e = n !== !1 && Ht(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, js = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const s = e.indexOf(t, n);
  return s !== -1 && s === n;
}, Gs = (e) => {
  if (!e)
    return null;
  if (Te(e))
    return e;
  let t = e.length;
  if (!zn(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Ws = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Ht(Uint8Array)), qs = (e, t) => {
  const s = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = s.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, Vs = (e, t) => {
  let n;
  const s = [];
  for (; (n = e.exec(t)) !== null; )
    s.push(n);
  return s;
}, Ks = Q("HTMLFormElement"), Js = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, s, o) {
    return s.toUpperCase() + o;
  }
), hn = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ys = Q("RegExp"), Gn = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), s = {};
  Oe(n, (o, i) => {
    t(o, i, e) !== !1 && (s[i] = o);
  }), Object.defineProperties(e, s);
}, Qs = (e) => {
  Gn(e, (t, n) => {
    if (j(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const s = e[n];
    if (j(s)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Xs = (e, t) => {
  const n = {}, s = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return Te(e) ? s(e) : s(String(e).split(t)), n;
}, Zs = () => {
}, eo = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Tt = "abcdefghijklmnopqrstuvwxyz", _n = "0123456789", Wn = {
  DIGIT: _n,
  ALPHA: Tt,
  ALPHA_DIGIT: Tt + Tt.toUpperCase() + _n
}, to = (e = 16, t = Wn.ALPHA_DIGIT) => {
  let n = "";
  const { length: s } = t;
  for (; e--; )
    n += t[Math.random() * s | 0];
  return n;
};
function no(e) {
  return !!(e && j(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const so = (e) => {
  const t = new Array(10), n = (s, o) => {
    if (Ye(s)) {
      if (t.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        t[o] = s;
        const i = Te(s) ? [] : {};
        return Oe(s, (r, u) => {
          const f = n(r, o + 1);
          !ve(f) && (i[u] = f);
        }), t[o] = void 0, i;
      }
    }
    return s;
  };
  return n(e, 0);
}, oo = Q("AsyncFunction"), io = (e) => e && (Ye(e) || j(e)) && j(e.then) && j(e.catch), l = {
  isArray: Te,
  isArrayBuffer: Hn,
  isBuffer: vs,
  isFormData: xs,
  isArrayBufferView: Os,
  isString: Cs,
  isNumber: zn,
  isBoolean: Ls,
  isObject: Ye,
  isPlainObject: Be,
  isUndefined: ve,
  isDate: Is,
  isFile: Ds,
  isBlob: Ns,
  isRegExp: Ys,
  isFunction: j,
  isStream: Ms,
  isURLSearchParams: Fs,
  isTypedArray: Ws,
  isFileList: Ps,
  forEach: Oe,
  merge: Dt,
  extend: Hs,
  trim: Us,
  stripBOM: zs,
  inherits: $s,
  toFlatObject: Bs,
  kindOf: Ke,
  kindOfTest: Q,
  endsWith: js,
  toArray: Gs,
  forEachEntry: qs,
  matchAll: Vs,
  isHTMLForm: Ks,
  hasOwnProperty: hn,
  hasOwnProp: hn,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Gn,
  freezeMethods: Qs,
  toObjectSet: Xs,
  toCamelCase: Js,
  noop: Zs,
  toFiniteNumber: eo,
  findKey: $n,
  global: Bn,
  isContextDefined: jn,
  ALPHABET: Wn,
  generateString: to,
  isSpecCompliantForm: no,
  toJSONObject: so,
  isAsyncFn: oo,
  isThenable: io
};
function b(e, t, n, s, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), s && (this.request = s), o && (this.response = o);
}
l.inherits(b, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: l.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const qn = b.prototype, Vn = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Vn[e] = { value: e };
});
Object.defineProperties(b, Vn);
Object.defineProperty(qn, "isAxiosError", { value: !0 });
b.from = (e, t, n, s, o, i) => {
  const r = Object.create(qn);
  return l.toFlatObject(e, r, function(f) {
    return f !== Error.prototype;
  }, (u) => u !== "isAxiosError"), b.call(r, e.message, t, n, s, o), r.cause = e, r.name = e.name, i && Object.assign(r, i), r;
};
const ro = null;
function Nt(e) {
  return l.isPlainObject(e) || l.isArray(e);
}
function Kn(e) {
  return l.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function gn(e, t, n) {
  return e ? e.concat(t).map(function(o, i) {
    return o = Kn(o), !n && i ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function ao(e) {
  return l.isArray(e) && !e.some(Nt);
}
const lo = l.toFlatObject(l, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Qe(e, t, n) {
  if (!l.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = l.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(y, F) {
    return !l.isUndefined(F[y]);
  });
  const s = n.metaTokens, o = n.visitor || h, i = n.dots, r = n.indexes, f = (n.Blob || typeof Blob < "u" && Blob) && l.isSpecCompliantForm(t);
  if (!l.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(d) {
    if (d === null)
      return "";
    if (l.isDate(d))
      return d.toISOString();
    if (!f && l.isBlob(d))
      throw new b("Blob is not supported. Use a Buffer instead.");
    return l.isArrayBuffer(d) || l.isTypedArray(d) ? f && typeof Blob == "function" ? new Blob([d]) : Buffer.from(d) : d;
  }
  function h(d, y, F) {
    let I = d;
    if (d && !F && typeof d == "object") {
      if (l.endsWith(y, "{}"))
        y = s ? y : y.slice(0, -2), d = JSON.stringify(d);
      else if (l.isArray(d) && ao(d) || (l.isFileList(d) || l.endsWith(y, "[]")) && (I = l.toArray(d)))
        return y = Kn(y), I.forEach(function(k, C) {
          !(l.isUndefined(k) || k === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            r === !0 ? gn([y], C, i) : r === null ? y : y + "[]",
            c(k)
          );
        }), !1;
    }
    return Nt(d) ? !0 : (t.append(gn(F, y, i), c(d)), !1);
  }
  const _ = [], T = Object.assign(lo, {
    defaultVisitor: h,
    convertValue: c,
    isVisitable: Nt
  });
  function E(d, y) {
    if (!l.isUndefined(d)) {
      if (_.indexOf(d) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      _.push(d), l.forEach(d, function(I, O) {
        (!(l.isUndefined(I) || I === null) && o.call(
          t,
          I,
          l.isString(O) ? O.trim() : O,
          y,
          T
        )) === !0 && E(I, y ? y.concat(O) : [O]);
      }), _.pop();
    }
  }
  if (!l.isObject(e))
    throw new TypeError("data must be an object");
  return E(e), t;
}
function yn(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(s) {
    return t[s];
  });
}
function zt(e, t) {
  this._pairs = [], e && Qe(e, this, t);
}
const Jn = zt.prototype;
Jn.append = function(t, n) {
  this._pairs.push([t, n]);
};
Jn.toString = function(t) {
  const n = t ? function(s) {
    return t.call(this, s, yn);
  } : yn;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function co(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Yn(e, t, n) {
  if (!t)
    return e;
  const s = n && n.encode || co, o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = l.isURLSearchParams(t) ? t.toString() : new zt(t, n).toString(s), i) {
    const r = e.indexOf("#");
    r !== -1 && (e = e.slice(0, r)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class uo {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, s) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    l.forEach(this.handlers, function(s) {
      s !== null && t(s);
    });
  }
}
const Tn = uo, Qn = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, po = typeof URLSearchParams < "u" ? URLSearchParams : zt, fo = typeof FormData < "u" ? FormData : null, mo = typeof Blob < "u" ? Blob : null, ho = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), _o = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), K = {
  isBrowser: !0,
  classes: {
    URLSearchParams: po,
    FormData: fo,
    Blob: mo
  },
  isStandardBrowserEnv: ho,
  isStandardBrowserWebWorkerEnv: _o,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function go(e, t) {
  return Qe(e, new K.classes.URLSearchParams(), Object.assign({
    visitor: function(n, s, o, i) {
      return K.isNode && l.isBuffer(n) ? (this.append(s, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function yo(e) {
  return l.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function To(e) {
  const t = {}, n = Object.keys(e);
  let s;
  const o = n.length;
  let i;
  for (s = 0; s < o; s++)
    i = n[s], t[i] = e[i];
  return t;
}
function Xn(e) {
  function t(n, s, o, i) {
    let r = n[i++];
    const u = Number.isFinite(+r), f = i >= n.length;
    return r = !r && l.isArray(o) ? o.length : r, f ? (l.hasOwnProp(o, r) ? o[r] = [o[r], s] : o[r] = s, !u) : ((!o[r] || !l.isObject(o[r])) && (o[r] = []), t(n, s, o[r], i) && l.isArray(o[r]) && (o[r] = To(o[r])), !u);
  }
  if (l.isFormData(e) && l.isFunction(e.entries)) {
    const n = {};
    return l.forEachEntry(e, (s, o) => {
      t(yo(s), o, n, 0);
    }), n;
  }
  return null;
}
const Eo = {
  "Content-Type": void 0
};
function Ao(e, t, n) {
  if (l.isString(e))
    try {
      return (t || JSON.parse)(e), l.trim(e);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (n || JSON.stringify)(e);
}
const Xe = {
  transitional: Qn,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const s = n.getContentType() || "", o = s.indexOf("application/json") > -1, i = l.isObject(t);
    if (i && l.isHTMLForm(t) && (t = new FormData(t)), l.isFormData(t))
      return o && o ? JSON.stringify(Xn(t)) : t;
    if (l.isArrayBuffer(t) || l.isBuffer(t) || l.isStream(t) || l.isFile(t) || l.isBlob(t))
      return t;
    if (l.isArrayBufferView(t))
      return t.buffer;
    if (l.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let u;
    if (i) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return go(t, this.formSerializer).toString();
      if ((u = l.isFileList(t)) || s.indexOf("multipart/form-data") > -1) {
        const f = this.env && this.env.FormData;
        return Qe(
          u ? { "files[]": t } : t,
          f && new f(),
          this.formSerializer
        );
      }
    }
    return i || o ? (n.setContentType("application/json", !1), Ao(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Xe.transitional, s = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (t && l.isString(t) && (s && !this.responseType || o)) {
      const r = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (u) {
        if (r)
          throw u.name === "SyntaxError" ? b.from(u, b.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: K.classes.FormData,
    Blob: K.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
l.forEach(["delete", "get", "head"], function(t) {
  Xe.headers[t] = {};
});
l.forEach(["post", "put", "patch"], function(t) {
  Xe.headers[t] = l.merge(Eo);
});
const $t = Xe, bo = l.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), wo = (e) => {
  const t = {};
  let n, s, o;
  return e && e.split(`
`).forEach(function(r) {
    o = r.indexOf(":"), n = r.substring(0, o).trim().toLowerCase(), s = r.substring(o + 1).trim(), !(!n || t[n] && bo[n]) && (n === "set-cookie" ? t[n] ? t[n].push(s) : t[n] = [s] : t[n] = t[n] ? t[n] + ", " + s : s);
  }), t;
}, En = Symbol("internals");
function we(e) {
  return e && String(e).trim().toLowerCase();
}
function je(e) {
  return e === !1 || e == null ? e : l.isArray(e) ? e.map(je) : String(e);
}
function So(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = n.exec(e); )
    t[s[1]] = s[2];
  return t;
}
const ko = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Et(e, t, n, s, o) {
  if (l.isFunction(s))
    return s.call(this, t, n);
  if (o && (t = n), !!l.isString(t)) {
    if (l.isString(s))
      return t.indexOf(s) !== -1;
    if (l.isRegExp(s))
      return s.test(t);
  }
}
function Ro(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, s) => n.toUpperCase() + s);
}
function vo(e, t) {
  const n = l.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(e, s + n, {
      value: function(o, i, r) {
        return this[s].call(this, t, o, i, r);
      },
      configurable: !0
    });
  });
}
class Ze {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, s) {
    const o = this;
    function i(u, f, c) {
      const h = we(f);
      if (!h)
        throw new Error("header name must be a non-empty string");
      const _ = l.findKey(o, h);
      (!_ || o[_] === void 0 || c === !0 || c === void 0 && o[_] !== !1) && (o[_ || f] = je(u));
    }
    const r = (u, f) => l.forEach(u, (c, h) => i(c, h, f));
    return l.isPlainObject(t) || t instanceof this.constructor ? r(t, n) : l.isString(t) && (t = t.trim()) && !ko(t) ? r(wo(t), n) : t != null && i(n, t, s), this;
  }
  get(t, n) {
    if (t = we(t), t) {
      const s = l.findKey(this, t);
      if (s) {
        const o = this[s];
        if (!n)
          return o;
        if (n === !0)
          return So(o);
        if (l.isFunction(n))
          return n.call(this, o, s);
        if (l.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = we(t), t) {
      const s = l.findKey(this, t);
      return !!(s && this[s] !== void 0 && (!n || Et(this, this[s], s, n)));
    }
    return !1;
  }
  delete(t, n) {
    const s = this;
    let o = !1;
    function i(r) {
      if (r = we(r), r) {
        const u = l.findKey(s, r);
        u && (!n || Et(s, s[u], u, n)) && (delete s[u], o = !0);
      }
    }
    return l.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let s = n.length, o = !1;
    for (; s--; ) {
      const i = n[s];
      (!t || Et(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, s = {};
    return l.forEach(this, (o, i) => {
      const r = l.findKey(s, i);
      if (r) {
        n[r] = je(o), delete n[i];
        return;
      }
      const u = t ? Ro(i) : String(i).trim();
      u !== i && delete n[i], n[u] = je(o), s[u] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return l.forEach(this, (s, o) => {
      s != null && s !== !1 && (n[o] = t && l.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const s = new this(t);
    return n.forEach((o) => s.set(o)), s;
  }
  static accessor(t) {
    const s = (this[En] = this[En] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(r) {
      const u = we(r);
      s[u] || (vo(o, r), s[u] = !0);
    }
    return l.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
Ze.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
l.freezeMethods(Ze.prototype);
l.freezeMethods(Ze);
const ee = Ze;
function At(e, t) {
  const n = this || $t, s = t || n, o = ee.from(s.headers);
  let i = s.data;
  return l.forEach(e, function(u) {
    i = u.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function Zn(e) {
  return !!(e && e.__CANCEL__);
}
function Ce(e, t, n) {
  b.call(this, e ?? "canceled", b.ERR_CANCELED, t, n), this.name = "CanceledError";
}
l.inherits(Ce, b, {
  __CANCEL__: !0
});
function Oo(e, t, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status) ? e(n) : t(new b(
    "Request failed with status code " + n.status,
    [b.ERR_BAD_REQUEST, b.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const Co = K.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(n, s, o, i, r, u) {
        const f = [];
        f.push(n + "=" + encodeURIComponent(s)), l.isNumber(o) && f.push("expires=" + new Date(o).toGMTString()), l.isString(i) && f.push("path=" + i), l.isString(r) && f.push("domain=" + r), u === !0 && f.push("secure"), document.cookie = f.join("; ");
      },
      read: function(n) {
        const s = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return s ? decodeURIComponent(s[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function Lo(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Io(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function es(e, t) {
  return e && !Lo(t) ? Io(e, t) : t;
}
const Do = K.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let s;
    function o(i) {
      let r = i;
      return t && (n.setAttribute("href", r), r = n.href), n.setAttribute("href", r), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return s = o(window.location.href), function(r) {
      const u = l.isString(r) ? o(r) : r;
      return u.protocol === s.protocol && u.host === s.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function No(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Po(e, t) {
  e = e || 10;
  const n = new Array(e), s = new Array(e);
  let o = 0, i = 0, r;
  return t = t !== void 0 ? t : 1e3, function(f) {
    const c = Date.now(), h = s[i];
    r || (r = c), n[o] = f, s[o] = c;
    let _ = i, T = 0;
    for (; _ !== o; )
      T += n[_++], _ = _ % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), c - r < t)
      return;
    const E = h && c - h;
    return E ? Math.round(T * 1e3 / E) : void 0;
  };
}
function An(e, t) {
  let n = 0;
  const s = Po(50, 250);
  return (o) => {
    const i = o.loaded, r = o.lengthComputable ? o.total : void 0, u = i - n, f = s(u), c = i <= r;
    n = i;
    const h = {
      loaded: i,
      total: r,
      progress: r ? i / r : void 0,
      bytes: u,
      rate: f || void 0,
      estimated: f && r && c ? (r - i) / f : void 0,
      event: o
    };
    h[t ? "download" : "upload"] = !0, e(h);
  };
}
const Mo = typeof XMLHttpRequest < "u", xo = Mo && function(e) {
  return new Promise(function(n, s) {
    let o = e.data;
    const i = ee.from(e.headers).normalize(), r = e.responseType;
    let u;
    function f() {
      e.cancelToken && e.cancelToken.unsubscribe(u), e.signal && e.signal.removeEventListener("abort", u);
    }
    l.isFormData(o) && (K.isStandardBrowserEnv || K.isStandardBrowserWebWorkerEnv ? i.setContentType(!1) : i.setContentType("multipart/form-data;", !1));
    let c = new XMLHttpRequest();
    if (e.auth) {
      const E = e.auth.username || "", d = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      i.set("Authorization", "Basic " + btoa(E + ":" + d));
    }
    const h = es(e.baseURL, e.url);
    c.open(e.method.toUpperCase(), Yn(h, e.params, e.paramsSerializer), !0), c.timeout = e.timeout;
    function _() {
      if (!c)
        return;
      const E = ee.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), y = {
        data: !r || r === "text" || r === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: E,
        config: e,
        request: c
      };
      Oo(function(I) {
        n(I), f();
      }, function(I) {
        s(I), f();
      }, y), c = null;
    }
    if ("onloadend" in c ? c.onloadend = _ : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(_);
    }, c.onabort = function() {
      c && (s(new b("Request aborted", b.ECONNABORTED, e, c)), c = null);
    }, c.onerror = function() {
      s(new b("Network Error", b.ERR_NETWORK, e, c)), c = null;
    }, c.ontimeout = function() {
      let d = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const y = e.transitional || Qn;
      e.timeoutErrorMessage && (d = e.timeoutErrorMessage), s(new b(
        d,
        y.clarifyTimeoutError ? b.ETIMEDOUT : b.ECONNABORTED,
        e,
        c
      )), c = null;
    }, K.isStandardBrowserEnv) {
      const E = (e.withCredentials || Do(h)) && e.xsrfCookieName && Co.read(e.xsrfCookieName);
      E && i.set(e.xsrfHeaderName, E);
    }
    o === void 0 && i.setContentType(null), "setRequestHeader" in c && l.forEach(i.toJSON(), function(d, y) {
      c.setRequestHeader(y, d);
    }), l.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), r && r !== "json" && (c.responseType = e.responseType), typeof e.onDownloadProgress == "function" && c.addEventListener("progress", An(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", An(e.onUploadProgress)), (e.cancelToken || e.signal) && (u = (E) => {
      c && (s(!E || E.type ? new Ce(null, e, c) : E), c.abort(), c = null);
    }, e.cancelToken && e.cancelToken.subscribe(u), e.signal && (e.signal.aborted ? u() : e.signal.addEventListener("abort", u)));
    const T = No(h);
    if (T && K.protocols.indexOf(T) === -1) {
      s(new b("Unsupported protocol " + T + ":", b.ERR_BAD_REQUEST, e));
      return;
    }
    c.send(o || null);
  });
}, Ge = {
  http: ro,
  xhr: xo
};
l.forEach(Ge, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Fo = {
  getAdapter: (e) => {
    e = l.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, s;
    for (let o = 0; o < t && (n = e[o], !(s = l.isString(n) ? Ge[n.toLowerCase()] : n)); o++)
      ;
    if (!s)
      throw s === !1 ? new b(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        l.hasOwnProp(Ge, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!l.isFunction(s))
      throw new TypeError("adapter is not a function");
    return s;
  },
  adapters: Ge
};
function bt(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ce(null, e);
}
function bn(e) {
  return bt(e), e.headers = ee.from(e.headers), e.data = At.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Fo.getAdapter(e.adapter || $t.adapter)(e).then(function(s) {
    return bt(e), s.data = At.call(
      e,
      e.transformResponse,
      s
    ), s.headers = ee.from(s.headers), s;
  }, function(s) {
    return Zn(s) || (bt(e), s && s.response && (s.response.data = At.call(
      e,
      e.transformResponse,
      s.response
    ), s.response.headers = ee.from(s.response.headers))), Promise.reject(s);
  });
}
const wn = (e) => e instanceof ee ? e.toJSON() : e;
function ye(e, t) {
  t = t || {};
  const n = {};
  function s(c, h, _) {
    return l.isPlainObject(c) && l.isPlainObject(h) ? l.merge.call({ caseless: _ }, c, h) : l.isPlainObject(h) ? l.merge({}, h) : l.isArray(h) ? h.slice() : h;
  }
  function o(c, h, _) {
    if (l.isUndefined(h)) {
      if (!l.isUndefined(c))
        return s(void 0, c, _);
    } else
      return s(c, h, _);
  }
  function i(c, h) {
    if (!l.isUndefined(h))
      return s(void 0, h);
  }
  function r(c, h) {
    if (l.isUndefined(h)) {
      if (!l.isUndefined(c))
        return s(void 0, c);
    } else
      return s(void 0, h);
  }
  function u(c, h, _) {
    if (_ in t)
      return s(c, h);
    if (_ in e)
      return s(void 0, c);
  }
  const f = {
    url: i,
    method: i,
    data: i,
    baseURL: r,
    transformRequest: r,
    transformResponse: r,
    paramsSerializer: r,
    timeout: r,
    timeoutMessage: r,
    withCredentials: r,
    adapter: r,
    responseType: r,
    xsrfCookieName: r,
    xsrfHeaderName: r,
    onUploadProgress: r,
    onDownloadProgress: r,
    decompress: r,
    maxContentLength: r,
    maxBodyLength: r,
    beforeRedirect: r,
    transport: r,
    httpAgent: r,
    httpsAgent: r,
    cancelToken: r,
    socketPath: r,
    responseEncoding: r,
    validateStatus: u,
    headers: (c, h) => o(wn(c), wn(h), !0)
  };
  return l.forEach(Object.keys(Object.assign({}, e, t)), function(h) {
    const _ = f[h] || o, T = _(e[h], t[h], h);
    l.isUndefined(T) && _ !== u || (n[h] = T);
  }), n;
}
const ts = "1.4.0", Bt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Bt[e] = function(s) {
    return typeof s === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Sn = {};
Bt.transitional = function(t, n, s) {
  function o(i, r) {
    return "[Axios v" + ts + "] Transitional option '" + i + "'" + r + (s ? ". " + s : "");
  }
  return (i, r, u) => {
    if (t === !1)
      throw new b(
        o(r, " has been removed" + (n ? " in " + n : "")),
        b.ERR_DEPRECATED
      );
    return n && !Sn[r] && (Sn[r] = !0, console.warn(
      o(
        r,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, r, u) : !0;
  };
};
function Uo(e, t, n) {
  if (typeof e != "object")
    throw new b("options must be an object", b.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let o = s.length;
  for (; o-- > 0; ) {
    const i = s[o], r = t[i];
    if (r) {
      const u = e[i], f = u === void 0 || r(u, i, e);
      if (f !== !0)
        throw new b("option " + i + " must be " + f, b.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new b("Unknown option " + i, b.ERR_BAD_OPTION);
  }
}
const Pt = {
  assertOptions: Uo,
  validators: Bt
}, te = Pt.validators;
class Ve {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Tn(),
      response: new Tn()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = ye(this.defaults, n);
    const { transitional: s, paramsSerializer: o, headers: i } = n;
    s !== void 0 && Pt.assertOptions(s, {
      silentJSONParsing: te.transitional(te.boolean),
      forcedJSONParsing: te.transitional(te.boolean),
      clarifyTimeoutError: te.transitional(te.boolean)
    }, !1), o != null && (l.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : Pt.assertOptions(o, {
      encode: te.function,
      serialize: te.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let r;
    r = i && l.merge(
      i.common,
      i[n.method]
    ), r && l.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (d) => {
        delete i[d];
      }
    ), n.headers = ee.concat(r, i);
    const u = [];
    let f = !0;
    this.interceptors.request.forEach(function(y) {
      typeof y.runWhen == "function" && y.runWhen(n) === !1 || (f = f && y.synchronous, u.unshift(y.fulfilled, y.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(y) {
      c.push(y.fulfilled, y.rejected);
    });
    let h, _ = 0, T;
    if (!f) {
      const d = [bn.bind(this), void 0];
      for (d.unshift.apply(d, u), d.push.apply(d, c), T = d.length, h = Promise.resolve(n); _ < T; )
        h = h.then(d[_++], d[_++]);
      return h;
    }
    T = u.length;
    let E = n;
    for (_ = 0; _ < T; ) {
      const d = u[_++], y = u[_++];
      try {
        E = d(E);
      } catch (F) {
        y.call(this, F);
        break;
      }
    }
    try {
      h = bn.call(this, E);
    } catch (d) {
      return Promise.reject(d);
    }
    for (_ = 0, T = c.length; _ < T; )
      h = h.then(c[_++], c[_++]);
    return h;
  }
  getUri(t) {
    t = ye(this.defaults, t);
    const n = es(t.baseURL, t.url);
    return Yn(n, t.params, t.paramsSerializer);
  }
}
l.forEach(["delete", "get", "head", "options"], function(t) {
  Ve.prototype[t] = function(n, s) {
    return this.request(ye(s || {}, {
      method: t,
      url: n,
      data: (s || {}).data
    }));
  };
});
l.forEach(["post", "put", "patch"], function(t) {
  function n(s) {
    return function(i, r, u) {
      return this.request(ye(u || {}, {
        method: t,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: r
      }));
    };
  }
  Ve.prototype[t] = n(), Ve.prototype[t + "Form"] = n(!0);
});
const We = Ve;
class jt {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const s = this;
    this.promise.then((o) => {
      if (!s._listeners)
        return;
      let i = s._listeners.length;
      for (; i-- > 0; )
        s._listeners[i](o);
      s._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const r = new Promise((u) => {
        s.subscribe(u), i = u;
      }).then(o);
      return r.cancel = function() {
        s.unsubscribe(i);
      }, r;
    }, t(function(i, r, u) {
      s.reason || (s.reason = new Ce(i, r, u), n(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new jt(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
const Ho = jt;
function zo(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function $o(e) {
  return l.isObject(e) && e.isAxiosError === !0;
}
const Mt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Mt).forEach(([e, t]) => {
  Mt[t] = e;
});
const Bo = Mt;
function ns(e) {
  const t = new We(e), n = Un(We.prototype.request, t);
  return l.extend(n, We.prototype, t, { allOwnKeys: !0 }), l.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return ns(ye(e, o));
  }, n;
}
const L = ns($t);
L.Axios = We;
L.CanceledError = Ce;
L.CancelToken = Ho;
L.isCancel = Zn;
L.VERSION = ts;
L.toFormData = Qe;
L.AxiosError = b;
L.Cancel = L.CanceledError;
L.all = function(t) {
  return Promise.all(t);
};
L.spread = zo;
L.isAxiosError = $o;
L.mergeConfig = ye;
L.AxiosHeaders = ee;
L.formToJSON = (e) => Xn(l.isHTMLForm(e) ? new FormData(e) : e);
L.HttpStatusCode = Bo;
L.default = L;
const et = L;
let Ue;
const jo = new Uint8Array(16);
function Go() {
  if (!Ue && (Ue = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Ue))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ue(jo);
}
const x = [];
for (let e = 0; e < 256; ++e)
  x.push((e + 256).toString(16).slice(1));
function Wo(e, t = 0) {
  return (x[e[t + 0]] + x[e[t + 1]] + x[e[t + 2]] + x[e[t + 3]] + "-" + x[e[t + 4]] + x[e[t + 5]] + "-" + x[e[t + 6]] + x[e[t + 7]] + "-" + x[e[t + 8]] + x[e[t + 9]] + "-" + x[e[t + 10]] + x[e[t + 11]] + x[e[t + 12]] + x[e[t + 13]] + x[e[t + 14]] + x[e[t + 15]]).toLowerCase();
}
const qo = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), kn = {
  randomUUID: qo
};
function Vo(e, t, n) {
  if (kn.randomUUID && !t && !e)
    return kn.randomUUID();
  e = e || {};
  const s = e.random || (e.rng || Go)();
  if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, t) {
    n = n || 0;
    for (let o = 0; o < 16; ++o)
      t[n + o] = s[o];
    return t;
  }
  return Wo(s);
}
const ss = () => /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), os = () => !0, Gt = () => /iPhone|iPad|iPod/i.test(navigator.userAgent), Ko = () => /android/i.test(navigator.userAgent), is = () => window.location.href.startsWith("https://pay.kaspi.kz"), Jo = () => {
  var n;
  if (!is())
    return null;
  const e = (n = document.cookie.split("; ").find((s) => s.startsWith("kb_app_version="))) == null ? void 0 : n.split("=")[1];
  if (!e || typeof e == "number")
    return e;
  let t = e.split(".");
  return +(t.shift() + (t.length ? "." + t.join("") : ""));
}, Yo = (e) => !e || e > 4.25 ? "webViewJsBridge" : "helpJsProxy";
/*! @license DOMPurify 3.0.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.5/LICENSE */
const {
  entries: rs,
  setPrototypeOf: Rn,
  isFrozen: Qo,
  getPrototypeOf: Xo,
  getOwnPropertyDescriptor: Zo
} = Object;
let {
  freeze: U,
  seal: q,
  create: ei
} = Object, {
  apply: xt,
  construct: Ft
} = typeof Reflect < "u" && Reflect;
xt || (xt = function(t, n, s) {
  return t.apply(n, s);
});
U || (U = function(t) {
  return t;
});
q || (q = function(t) {
  return t;
});
Ft || (Ft = function(t, n) {
  return new t(...n);
});
const ti = G(Array.prototype.forEach), vn = G(Array.prototype.pop), Se = G(Array.prototype.push), qe = G(String.prototype.toLowerCase), wt = G(String.prototype.toString), ni = G(String.prototype.match), W = G(String.prototype.replace), si = G(String.prototype.indexOf), oi = G(String.prototype.trim), z = G(RegExp.prototype.test), ke = ii(TypeError);
function G(e) {
  return function(t) {
    for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      s[o - 1] = arguments[o];
    return xt(e, t, s);
  };
}
function ii(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), s = 0; s < t; s++)
      n[s] = arguments[s];
    return Ft(e, n);
  };
}
function A(e, t, n) {
  var s;
  n = (s = n) !== null && s !== void 0 ? s : qe, Rn && Rn(e, null);
  let o = t.length;
  for (; o--; ) {
    let i = t[o];
    if (typeof i == "string") {
      const r = n(i);
      r !== i && (Qo(t) || (t[o] = r), i = r);
    }
    e[i] = !0;
  }
  return e;
}
function _e(e) {
  const t = ei(null);
  for (const [n, s] of rs(e))
    t[n] = s;
  return t;
}
function He(e, t) {
  for (; e !== null; ) {
    const s = Zo(e, t);
    if (s) {
      if (s.get)
        return G(s.get);
      if (typeof s.value == "function")
        return G(s.value);
    }
    e = Xo(e);
  }
  function n(s) {
    return console.warn("fallback value for", s), null;
  }
  return n;
}
const On = U(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), St = U(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), kt = U(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), ri = U(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Rt = U(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), ai = U(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Cn = U(["#text"]), Ln = U(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), vt = U(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), In = U(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), ze = U(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), li = q(/\{\{[\w\W]*|[\w\W]*\}\}/gm), ci = q(/<%[\w\W]*|[\w\W]*%>/gm), ui = q(/\${[\w\W]*}/gm), pi = q(/^data-[\-\w.\u00B7-\uFFFF]/), di = q(/^aria-[\-\w]+$/), as = q(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), fi = q(/^(?:\w+script|data):/i), mi = q(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), ls = q(/^html$/i);
var Dn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: li,
  ERB_EXPR: ci,
  TMPLIT_EXPR: ui,
  DATA_ATTR: pi,
  ARIA_ATTR: di,
  IS_ALLOWED_URI: as,
  IS_SCRIPT_OR_DATA: fi,
  ATTR_WHITESPACE: mi,
  DOCTYPE_NAME: ls
});
const hi = () => typeof window > "u" ? null : window, _i = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let s = null;
  const o = "data-tt-policy-suffix";
  n && n.hasAttribute(o) && (s = n.getAttribute(o));
  const i = "dompurify" + (s ? "#" + s : "");
  try {
    return t.createPolicy(i, {
      createHTML(r) {
        return r;
      },
      createScriptURL(r) {
        return r;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
};
function cs() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : hi();
  const t = (g) => cs(g);
  if (t.version = "3.0.5", t.removed = [], !e || !e.document || e.document.nodeType !== 9)
    return t.isSupported = !1, t;
  const n = e.document, s = n.currentScript;
  let {
    document: o
  } = e;
  const {
    DocumentFragment: i,
    HTMLTemplateElement: r,
    Node: u,
    Element: f,
    NodeFilter: c,
    NamedNodeMap: h = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: _,
    DOMParser: T,
    trustedTypes: E
  } = e, d = f.prototype, y = He(d, "cloneNode"), F = He(d, "nextSibling"), I = He(d, "childNodes"), O = He(d, "parentNode");
  if (typeof r == "function") {
    const g = o.createElement("template");
    g.content && g.content.ownerDocument && (o = g.content.ownerDocument);
  }
  let k, C = "";
  const {
    implementation: $,
    createNodeIterator: ce,
    createDocumentFragment: ie,
    getElementsByTagName: S
  } = o, {
    importNode: Ie
  } = n;
  let H = {};
  t.isSupported = typeof rs == "function" && typeof O == "function" && $ && $.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: Ee,
    ERB_EXPR: it,
    TMPLIT_EXPR: rt,
    DATA_ATTR: ms,
    ARIA_ATTR: hs,
    IS_SCRIPT_OR_DATA: _s,
    ATTR_WHITESPACE: Wt
  } = Dn;
  let {
    IS_ALLOWED_URI: qt
  } = Dn, D = null;
  const Vt = A({}, [...On, ...St, ...kt, ...Rt, ...Cn]);
  let N = null;
  const Kt = A({}, [...Ln, ...vt, ...In, ...ze]);
  let v = Object.seal(Object.create(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Ae = null, at = null, Jt = !0, lt = !0, Yt = !1, Qt = !0, ue = !1, re = !1, ct = !1, ut = !1, pe = !1, De = !1, Ne = !1, Xt = !0, Zt = !1;
  const gs = "user-content-";
  let pt = !0, be = !1, de = {}, fe = null;
  const en = A({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let tn = null;
  const nn = A({}, ["audio", "video", "img", "source", "image", "track"]);
  let dt = null;
  const sn = A({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Pe = "http://www.w3.org/1998/Math/MathML", Me = "http://www.w3.org/2000/svg", X = "http://www.w3.org/1999/xhtml";
  let me = X, ft = !1, mt = null;
  const ys = A({}, [Pe, Me, X], wt);
  let ae;
  const Ts = ["application/xhtml+xml", "text/html"], Es = "text/html";
  let P, he = null;
  const As = o.createElement("form"), on = function(a) {
    return a instanceof RegExp || a instanceof Function;
  }, ht = function(a) {
    if (!(he && he === a)) {
      if ((!a || typeof a != "object") && (a = {}), a = _e(a), ae = // eslint-disable-next-line unicorn/prefer-includes
      Ts.indexOf(a.PARSER_MEDIA_TYPE) === -1 ? ae = Es : ae = a.PARSER_MEDIA_TYPE, P = ae === "application/xhtml+xml" ? wt : qe, D = "ALLOWED_TAGS" in a ? A({}, a.ALLOWED_TAGS, P) : Vt, N = "ALLOWED_ATTR" in a ? A({}, a.ALLOWED_ATTR, P) : Kt, mt = "ALLOWED_NAMESPACES" in a ? A({}, a.ALLOWED_NAMESPACES, wt) : ys, dt = "ADD_URI_SAFE_ATTR" in a ? A(
        _e(sn),
        // eslint-disable-line indent
        a.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        P
        // eslint-disable-line indent
      ) : sn, tn = "ADD_DATA_URI_TAGS" in a ? A(
        _e(nn),
        // eslint-disable-line indent
        a.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        P
        // eslint-disable-line indent
      ) : nn, fe = "FORBID_CONTENTS" in a ? A({}, a.FORBID_CONTENTS, P) : en, Ae = "FORBID_TAGS" in a ? A({}, a.FORBID_TAGS, P) : {}, at = "FORBID_ATTR" in a ? A({}, a.FORBID_ATTR, P) : {}, de = "USE_PROFILES" in a ? a.USE_PROFILES : !1, Jt = a.ALLOW_ARIA_ATTR !== !1, lt = a.ALLOW_DATA_ATTR !== !1, Yt = a.ALLOW_UNKNOWN_PROTOCOLS || !1, Qt = a.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ue = a.SAFE_FOR_TEMPLATES || !1, re = a.WHOLE_DOCUMENT || !1, pe = a.RETURN_DOM || !1, De = a.RETURN_DOM_FRAGMENT || !1, Ne = a.RETURN_TRUSTED_TYPE || !1, ut = a.FORCE_BODY || !1, Xt = a.SANITIZE_DOM !== !1, Zt = a.SANITIZE_NAMED_PROPS || !1, pt = a.KEEP_CONTENT !== !1, be = a.IN_PLACE || !1, qt = a.ALLOWED_URI_REGEXP || as, me = a.NAMESPACE || X, v = a.CUSTOM_ELEMENT_HANDLING || {}, a.CUSTOM_ELEMENT_HANDLING && on(a.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (v.tagNameCheck = a.CUSTOM_ELEMENT_HANDLING.tagNameCheck), a.CUSTOM_ELEMENT_HANDLING && on(a.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (v.attributeNameCheck = a.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), a.CUSTOM_ELEMENT_HANDLING && typeof a.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (v.allowCustomizedBuiltInElements = a.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), ue && (lt = !1), De && (pe = !0), de && (D = A({}, [...Cn]), N = [], de.html === !0 && (A(D, On), A(N, Ln)), de.svg === !0 && (A(D, St), A(N, vt), A(N, ze)), de.svgFilters === !0 && (A(D, kt), A(N, vt), A(N, ze)), de.mathMl === !0 && (A(D, Rt), A(N, In), A(N, ze))), a.ADD_TAGS && (D === Vt && (D = _e(D)), A(D, a.ADD_TAGS, P)), a.ADD_ATTR && (N === Kt && (N = _e(N)), A(N, a.ADD_ATTR, P)), a.ADD_URI_SAFE_ATTR && A(dt, a.ADD_URI_SAFE_ATTR, P), a.FORBID_CONTENTS && (fe === en && (fe = _e(fe)), A(fe, a.FORBID_CONTENTS, P)), pt && (D["#text"] = !0), re && A(D, ["html", "head", "body"]), D.table && (A(D, ["tbody"]), delete Ae.tbody), a.TRUSTED_TYPES_POLICY) {
        if (typeof a.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw ke('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof a.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw ke('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        k = a.TRUSTED_TYPES_POLICY, C = k.createHTML("");
      } else
        k === void 0 && (k = _i(E, s)), k !== null && typeof C == "string" && (C = k.createHTML(""));
      U && U(a), he = a;
    }
  }, rn = A({}, ["mi", "mo", "mn", "ms", "mtext"]), an = A({}, ["foreignobject", "desc", "title", "annotation-xml"]), bs = A({}, ["title", "style", "font", "a", "script"]), xe = A({}, St);
  A(xe, kt), A(xe, ri);
  const _t = A({}, Rt);
  A(_t, ai);
  const ws = function(a) {
    let p = O(a);
    (!p || !p.tagName) && (p = {
      namespaceURI: me,
      tagName: "template"
    });
    const m = qe(a.tagName), w = qe(p.tagName);
    return mt[a.namespaceURI] ? a.namespaceURI === Me ? p.namespaceURI === X ? m === "svg" : p.namespaceURI === Pe ? m === "svg" && (w === "annotation-xml" || rn[w]) : !!xe[m] : a.namespaceURI === Pe ? p.namespaceURI === X ? m === "math" : p.namespaceURI === Me ? m === "math" && an[w] : !!_t[m] : a.namespaceURI === X ? p.namespaceURI === Me && !an[w] || p.namespaceURI === Pe && !rn[w] ? !1 : !_t[m] && (bs[m] || !xe[m]) : !!(ae === "application/xhtml+xml" && mt[a.namespaceURI]) : !1;
  }, le = function(a) {
    Se(t.removed, {
      element: a
    });
    try {
      a.parentNode.removeChild(a);
    } catch {
      a.remove();
    }
  }, gt = function(a, p) {
    try {
      Se(t.removed, {
        attribute: p.getAttributeNode(a),
        from: p
      });
    } catch {
      Se(t.removed, {
        attribute: null,
        from: p
      });
    }
    if (p.removeAttribute(a), a === "is" && !N[a])
      if (pe || De)
        try {
          le(p);
        } catch {
        }
      else
        try {
          p.setAttribute(a, "");
        } catch {
        }
  }, ln = function(a) {
    let p, m;
    if (ut)
      a = "<remove></remove>" + a;
    else {
      const B = ni(a, /^[\r\n\t ]+/);
      m = B && B[0];
    }
    ae === "application/xhtml+xml" && me === X && (a = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + a + "</body></html>");
    const w = k ? k.createHTML(a) : a;
    if (me === X)
      try {
        p = new T().parseFromString(w, ae);
      } catch {
      }
    if (!p || !p.documentElement) {
      p = $.createDocument(me, "template", null);
      try {
        p.documentElement.innerHTML = ft ? C : w;
      } catch {
      }
    }
    const M = p.body || p.documentElement;
    return a && m && M.insertBefore(o.createTextNode(m), M.childNodes[0] || null), me === X ? S.call(p, re ? "html" : "body")[0] : re ? p.documentElement : M;
  }, cn = function(a) {
    return ce.call(
      a.ownerDocument || a,
      a,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT,
      null,
      !1
    );
  }, Ss = function(a) {
    return a instanceof _ && (typeof a.nodeName != "string" || typeof a.textContent != "string" || typeof a.removeChild != "function" || !(a.attributes instanceof h) || typeof a.removeAttribute != "function" || typeof a.setAttribute != "function" || typeof a.namespaceURI != "string" || typeof a.insertBefore != "function" || typeof a.hasChildNodes != "function");
  }, Fe = function(a) {
    return typeof u == "object" ? a instanceof u : a && typeof a == "object" && typeof a.nodeType == "number" && typeof a.nodeName == "string";
  }, Z = function(a, p, m) {
    H[a] && ti(H[a], (w) => {
      w.call(t, p, m, he);
    });
  }, un = function(a) {
    let p;
    if (Z("beforeSanitizeElements", a, null), Ss(a))
      return le(a), !0;
    const m = P(a.nodeName);
    if (Z("uponSanitizeElement", a, {
      tagName: m,
      allowedTags: D
    }), a.hasChildNodes() && !Fe(a.firstElementChild) && (!Fe(a.content) || !Fe(a.content.firstElementChild)) && z(/<[/\w]/g, a.innerHTML) && z(/<[/\w]/g, a.textContent))
      return le(a), !0;
    if (!D[m] || Ae[m]) {
      if (!Ae[m] && dn(m) && (v.tagNameCheck instanceof RegExp && z(v.tagNameCheck, m) || v.tagNameCheck instanceof Function && v.tagNameCheck(m)))
        return !1;
      if (pt && !fe[m]) {
        const w = O(a) || a.parentNode, M = I(a) || a.childNodes;
        if (M && w) {
          const B = M.length;
          for (let R = B - 1; R >= 0; --R)
            w.insertBefore(y(M[R], !0), F(a));
        }
      }
      return le(a), !0;
    }
    return a instanceof f && !ws(a) || (m === "noscript" || m === "noembed" || m === "noframes") && z(/<\/no(script|embed|frames)/i, a.innerHTML) ? (le(a), !0) : (ue && a.nodeType === 3 && (p = a.textContent, p = W(p, Ee, " "), p = W(p, it, " "), p = W(p, rt, " "), a.textContent !== p && (Se(t.removed, {
      element: a.cloneNode()
    }), a.textContent = p)), Z("afterSanitizeElements", a, null), !1);
  }, pn = function(a, p, m) {
    if (Xt && (p === "id" || p === "name") && (m in o || m in As))
      return !1;
    if (!(lt && !at[p] && z(ms, p))) {
      if (!(Jt && z(hs, p))) {
        if (!N[p] || at[p]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(dn(a) && (v.tagNameCheck instanceof RegExp && z(v.tagNameCheck, a) || v.tagNameCheck instanceof Function && v.tagNameCheck(a)) && (v.attributeNameCheck instanceof RegExp && z(v.attributeNameCheck, p) || v.attributeNameCheck instanceof Function && v.attributeNameCheck(p)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            p === "is" && v.allowCustomizedBuiltInElements && (v.tagNameCheck instanceof RegExp && z(v.tagNameCheck, m) || v.tagNameCheck instanceof Function && v.tagNameCheck(m)))
          )
            return !1;
        } else if (!dt[p]) {
          if (!z(qt, W(m, Wt, ""))) {
            if (!((p === "src" || p === "xlink:href" || p === "href") && a !== "script" && si(m, "data:") === 0 && tn[a])) {
              if (!(Yt && !z(_s, W(m, Wt, "")))) {
                if (m)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, dn = function(a) {
    return a.indexOf("-") > 0;
  }, fn = function(a) {
    let p, m, w, M;
    Z("beforeSanitizeAttributes", a, null);
    const {
      attributes: B
    } = a;
    if (!B)
      return;
    const R = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: N
    };
    for (M = B.length; M--; ) {
      p = B[M];
      const {
        name: V,
        namespaceURI: yt
      } = p;
      if (m = V === "value" ? p.value : oi(p.value), w = P(V), R.attrName = w, R.attrValue = m, R.keepAttr = !0, R.forceKeepAttr = void 0, Z("uponSanitizeAttribute", a, R), m = R.attrValue, R.forceKeepAttr || (gt(V, a), !R.keepAttr))
        continue;
      if (!Qt && z(/\/>/i, m)) {
        gt(V, a);
        continue;
      }
      ue && (m = W(m, Ee, " "), m = W(m, it, " "), m = W(m, rt, " "));
      const mn = P(a.nodeName);
      if (pn(mn, w, m)) {
        if (Zt && (w === "id" || w === "name") && (gt(V, a), m = gs + m), k && typeof E == "object" && typeof E.getAttributeType == "function" && !yt)
          switch (E.getAttributeType(mn, w)) {
            case "TrustedHTML": {
              m = k.createHTML(m);
              break;
            }
            case "TrustedScriptURL": {
              m = k.createScriptURL(m);
              break;
            }
          }
        try {
          yt ? a.setAttributeNS(yt, V, m) : a.setAttribute(V, m), vn(t.removed);
        } catch {
        }
      }
    }
    Z("afterSanitizeAttributes", a, null);
  }, ks = function g(a) {
    let p;
    const m = cn(a);
    for (Z("beforeSanitizeShadowDOM", a, null); p = m.nextNode(); )
      Z("uponSanitizeShadowNode", p, null), !un(p) && (p.content instanceof i && g(p.content), fn(p));
    Z("afterSanitizeShadowDOM", a, null);
  };
  return t.sanitize = function(g) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p, m, w, M;
    if (ft = !g, ft && (g = "<!-->"), typeof g != "string" && !Fe(g))
      if (typeof g.toString == "function") {
        if (g = g.toString(), typeof g != "string")
          throw ke("dirty is not a string, aborting");
      } else
        throw ke("toString is not a function");
    if (!t.isSupported)
      return g;
    if (ct || ht(a), t.removed = [], typeof g == "string" && (be = !1), be) {
      if (g.nodeName) {
        const V = P(g.nodeName);
        if (!D[V] || Ae[V])
          throw ke("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (g instanceof u)
      p = ln("<!---->"), m = p.ownerDocument.importNode(g, !0), m.nodeType === 1 && m.nodeName === "BODY" || m.nodeName === "HTML" ? p = m : p.appendChild(m);
    else {
      if (!pe && !ue && !re && // eslint-disable-next-line unicorn/prefer-includes
      g.indexOf("<") === -1)
        return k && Ne ? k.createHTML(g) : g;
      if (p = ln(g), !p)
        return pe ? null : Ne ? C : "";
    }
    p && ut && le(p.firstChild);
    const B = cn(be ? g : p);
    for (; w = B.nextNode(); )
      un(w) || (w.content instanceof i && ks(w.content), fn(w));
    if (be)
      return g;
    if (pe) {
      if (De)
        for (M = ie.call(p.ownerDocument); p.firstChild; )
          M.appendChild(p.firstChild);
      else
        M = p;
      return (N.shadowroot || N.shadowrootmode) && (M = Ie.call(n, M, !0)), M;
    }
    let R = re ? p.outerHTML : p.innerHTML;
    return re && D["!doctype"] && p.ownerDocument && p.ownerDocument.doctype && p.ownerDocument.doctype.name && z(ls, p.ownerDocument.doctype.name) && (R = "<!DOCTYPE " + p.ownerDocument.doctype.name + `>
` + R), ue && (R = W(R, Ee, " "), R = W(R, it, " "), R = W(R, rt, " ")), k && Ne ? k.createHTML(R) : R;
  }, t.setConfig = function(g) {
    ht(g), ct = !0;
  }, t.clearConfig = function() {
    he = null, ct = !1;
  }, t.isValidAttribute = function(g, a, p) {
    he || ht({});
    const m = P(g), w = P(a);
    return pn(m, w, p);
  }, t.addHook = function(g, a) {
    typeof a == "function" && (H[g] = H[g] || [], Se(H[g], a));
  }, t.removeHook = function(g) {
    if (H[g])
      return vn(H[g]);
  }, t.removeHooks = function(g) {
    H[g] && (H[g] = []);
  }, t.removeAllHooks = function() {
    H = {};
  }, t;
}
var gi = cs();
const us = (e) => Object.keys(e).reduce((t, n) => ((e[n] || e[n] === !1) && (t[n] = e[n]), t), {}), ps = (e) => Object.fromEntries(Object.entries(e).map(([t, n]) => [t, [n]])), Ut = (e) => typeof e == "string" ? gi.sanitize(e) : Array.isArray(e) ? e.map((t) => Ut(t)) : typeof e == "object" && e !== null ? Object.keys(e).reduce((t, n) => {
  const s = e[n];
  return t[n] = Ut(s), t;
}, {}) : e, yi = () => {
  const e = /* @__PURE__ */ new Date(), t = e.getTimezoneOffset(), n = t * 60 * 1e3, s = new Date(e.valueOf() - n).toISOString(), o = t / 60, i = Math.trunc(Math.abs(o)), r = (Math.abs(o) - i) * 60, u = Nn(i), f = Nn(r), c = t <= 0 ? "+" : "-";
  return s.replace("Z", `${c}${u}:${f}`);
};
function Nn(e) {
  return e < 10 ? "0" + e : "" + e;
}
let Le = "https://guide-test.kaspi.kz/snippet/api/v1", ds = null, Ti = Jo();
const tt = { withCredentials: !0 }, Ei = (e) => {
  Le = e;
}, Ai = (e, t = "ru") => new Promise((n) => {
  et.get(`${Le}/get/${t}/${e}`, tt).then((s) => {
    var o;
    return n((o = s.data) == null ? void 0 : o.body);
  }).catch(() => n(null));
}), bi = () => new Promise((e) => {
  et.get(`${Le}/analytics/token/get`, tt).then((t) => {
    var n, s;
    ds = (n = t.data) == null ? void 0 : n.body, e((s = t.data) == null ? void 0 : s.body);
  }).catch(() => e(null));
}), Ot = (e, t, n, s = null, o = "ru") => new Promise((i) => {
  et.post(`${Le}/vote/${o}`, {
    id: t.id,
    vote_type: e ? 0 : 1,
    negative_vote_reason: e ? null : n,
    user_comment: e ? null : s,
    vote_object: "Question",
    vote_user: {
      bank_customer_id: null,
      client_first_name: null,
      client_last_name: null,
      client_middle_name: null,
      client_phone: null,
      iin: null,
      sso_user_id: null
    }
  }, tt).then((r) => {
    var u;
    return i((u = r.data) == null ? void 0 : u.body);
  }).catch(() => i(null));
}), nt = (e, t, n = "ru") => new Promise((s) => {
  et.post(`${Le}/analytics/${n}/content`, {
    device: "mobileapp",
    iin: null,
    level: "info",
    phone: null,
    url: window.location.href,
    user_id: null,
    user_token: ds,
    user_type: null,
    action_type: e,
    body: t
  }, tt).then((o) => {
    var i;
    return s((i = o.data) == null ? void 0 : i.body);
  }).catch(() => s(null));
}), oe = (e, t = "ru") => {
  const n = [];
  if (Array.isArray(e))
    n.push(...e);
  else if (typeof e == "object")
    n.push(e);
  else
    return;
  const s = n.flatMap((o) => typeof o.name != "string" || typeof o.parameters != "object" ? [] : Ut({
    ...o,
    parameters: {
      ...o.parameters
    },
    id: Vo(),
    timestamp: yi()
  }));
  is() ? s.forEach((o) => Si({ event: o })) : s.forEach((o) => wi({ event: o }));
}, wi = ({ event: e }) => {
  try {
    const t = {
      event: e.name,
      parameters: us(e.parameters)
    };
    t.parameters = ps(t.parameters);
    const n = typeof t == "object" && t !== null ? JSON.stringify(t) : t;
    window.mobapp && window.mobapp.logAnalyticEvent && window.mobapp.logAnalyticEvent(n);
  } catch {
  }
}, Si = ({ event: e }) => {
  try {
    const t = us(e.parameters), n = JSON.stringify({
      name: e.name,
      // В МП Pay на iOS мы передаем обычный JS объект вида "{ foo: 123, bar: "hello" }"
      // В случае же с остальными устройствами, мы передаем объект вида "{ foo: [123], bar: ["hello"] }"
      params: Gt() ? t : ps(t)
    }), s = Yo(Ti);
    window[s] && window[s].sendAnalyticsEvent && window[s].sendAnalyticsEvent(n);
  } catch {
  }
}, ki = {
  snippetTitle: "Популярные вопросы",
  updated: "Обновлен",
  findAnswerHelpful1: "",
  findAnswerHelpful2: " считают ответ полезным",
  wasAnswerHelpful: "Для Вас ответ оказался полезным?",
  yes: "Да",
  no: "Нет",
  pleaseIndicateReason: "Пожалуйста, укажите причину:",
  dontLikeHowItWorks: "Мне не нравится, как это работает",
  knowHowImproveAnswer: "Я знаю как улучшить ответ",
  send: "Отправить",
  cancel: "Отмена",
  describeSuggestionImproveAnswer: "Опишите предложение по улучшению ответа",
  thanksForFeedback: "Спасибо за отзыв!",
  share: "Поделиться",
  mapsTitle: "Kaspi Maps доступен в мобильном приложении Kaspi.kz",
  bankTitle: "Мой Банк доступен в мобильном приложении Kaspi.kz",
  bankHistoryTitle: "Сканируйте, чтобы перейти в приложение Kaspi.kz",
  paymentTitle: "Оплатить услуги Вы можете в мобильном приложении Kaspi.kz",
  askFormTitle: "Задать вопрос",
  guideChatTitle: "Чат с Kaspi Гид",
  newServiceFormTitle: "Добавить услугу на Kaspi.kz",
  withdrawFormTitle: "Снятие денег с банкомата",
  cardFormTitle: "Возврат денег за покупку",
  cashInFormTitle: "Деньги не поступили",
  callsFormTitle: "Звонки с Kaspi.kz",
  endFormTitle: "Уведомление о регистрации смерти",
  fraudFormTitle: "Сообщить о мошенничестве",
  cancelTransactionFormTitle: "Отмена перевода",
  optimizationFormTitle: "Оптимальный кредит",
  scanToGoApp: "Сканируйте, чтобы перейти в приложение Kaspi.kz",
  fillFormInApp: "Заполнить форму<br>Вы можете в мобильном приложении Kaspi.kz",
  openGuideChatTitle: "Чат с Kaspi Гид доступен в мобильном приложении Kaspi.kz",
  formText: "Заполнить форму",
  symbolsLeft1: "Осталось",
  symbolsLeft2: "символов"
}, Ri = {
  snippetTitle: "Танымал сұрақтар",
  updated: "Жаңартылды",
  findAnswerHelpful1: "Қолданушылардың ",
  findAnswerHelpful2: " жауапты пайдалы деді.",
  wasAnswerHelpful: "Сізге жауап пайдалы болды ма?",
  yes: "Иә",
  no: "Жоқ",
  pleaseIndicateReason: "Өтінеміз, себебін көрсетіңізші:",
  dontLikeHowItWorks: "Маған мұның жұмысы ұнамады",
  knowHowImproveAnswer: "Мен жауапты жақсартуды білемін",
  send: "Жіберу",
  cancel: "Бас тарту",
  describeSuggestionImproveAnswer: "Жауапты жақсарту үшін ұсынысыңызды жазсаңыз",
  thanksForFeedback: "Пікір қалдырғаныңыз үшін алғыс білдіреміз!",
  share: "Бөлісу",
  mapsTitle: "Kaspi Maps бөлімін Kaspi.kz мобильді қосымшасында қолдана аласыз",
  bankTitle: "Жеке Банк бөлімін Kaspi.kz мобильді қосымшасында қолдана аласыз",
  bankHistoryTitle: "Kaspi.kz қосымшасына өту үшін сканерлеңіз",
  paymentTitle: "Қызмет ақысын  Kaspi.kz мобильді қосымшасында төлей аласыз",
  askFormTitle: "Сұрағыңыз бар ма?",
  guideChatTitle: "Kaspi Гид-пен чат",
  newServiceFormTitle: "Kaspi.kz-де қызмет қосу",
  withdrawFormTitle: "Банкоматтан ақша шешу",
  cardFormTitle: "Сатып алу үшін ақшаны қайтару",
  cashInFormTitle: "Ақша түспеді",
  callsFormTitle: "Kaspi.kz-тен қоңырау",
  endFormTitle: "Қайтыс болуды мемлекеттік тіркеу туралы хабарлама",
  fraudFormTitle: "Алаяқтық туралы хабарлау",
  cancelTransactionFormTitle: "Аударымның күшін жою",
  optimizationFormTitle: "Оңтайлы кредит",
  scanToGoApp: "Kaspi.kz мобильді қосымшасына өту үшін сканерлеңіз",
  fillFormInApp: "Kaspi.kz мобильді қосымшасында<br>Сіз үлгіні толтыра аласыз",
  openGuideChatTitle: "Kaspi.kz мобильді қосымшасында<br>Kaspi Гид-пен чат қолжетімді",
  formText: "Үлгіні толтырыңыз",
  symbolsLeft1: "",
  symbolsLeft2: "символ қалды"
}, vi = { ru: ki, kz: Ri }, se = (e, t) => vi[e][t], Oi = (e) => (t) => se(e, t);
let J = null, Y = null;
const Ci = (e, t, n) => {
  J = e, Y = t, nt("snippet_page", { page_type: "snippet", snippet_code: e }, n), oe({
    name: "guide_snippet_page_view",
    parameters: {
      snippet_code: J,
      snippet_name: Y
    }
  }, n);
}, Li = ({ question: e, lang: t, count: n, position: s }) => {
  nt("question_open", {
    page: "snippet",
    video_id: null,
    question: e.title,
    question_id: e.id,
    snippet_code: J,
    snippet_name: Y
  }, t), oe({
    name: "guide_question_click",
    parameters: {
      path: window.location.href || null,
      product_id: e.product_id || null,
      product_name: e.product_title || null,
      page_category: "snippet",
      question: e.title,
      question_id: e.id,
      selected_from: "list",
      type: "question",
      snippet_code: J,
      snippet_name: Y,
      question_count: n,
      question_position: s
    }
  }, t);
}, Ct = (e, t, n, s = null, o = "ru") => {
  nt("question_vote", {
    client_idea: e ? null : s,
    no_reason: e ? null : s ? se(o, "knowHowImproveAnswer") : se(o, "dontLikeHowItWorks"),
    publication_date: t.publication_date,
    question: t.title,
    question_id: t.id,
    vote: e ? "yes" : "no"
  }, o);
}, $e = ({ question: e, eventName: t, additionalParams: n, lang: s = "ru" }) => {
  oe({
    name: t,
    parameters: {
      ...n,
      product_id: (e == null ? void 0 : e.product_id) || null,
      product_name: (e == null ? void 0 : e.product_title) || null,
      question: e == null ? void 0 : e.title,
      question_id: e == null ? void 0 : e.id,
      snippet_code: J,
      snippet_name: Y,
      type: "question"
    }
  }, s);
}, Ii = ({ link: e, title: t, question: n, lang: s = "ru" }) => {
  nt("link_open", {
    link_url: e,
    link_title: t,
    question: {}
  }, s);
}, Di = ({ question: e, lang: t = "ru" }) => {
  oe({
    name: "guide_question_document_download_click",
    parameters: {
      product_id: e.product_id || null,
      product_name: e.product_title || null,
      question: e.title,
      question_id: e.id,
      type: "question",
      snippet_code: J,
      snippet_name: Y
    }
  }, t);
}, Pn = ({ eventFlag: e, videoId: t, videoSrc: n, question: s, lang: o = "ru" }) => {
  oe({
    name: e === "start" ? "guide_video_start" : "guide_video_full_viewed",
    parameters: {
      is_youtube: !1,
      product_id: (s == null ? void 0 : s.product_id) || null,
      product_name: (s == null ? void 0 : s.product_title) || null,
      question: s == null ? void 0 : s.title,
      question_id: s == null ? void 0 : s.id,
      type: "question",
      video_id: t,
      video_url: n,
      snippet_code: J,
      snippet_name: Y
    }
  }, o);
}, Ni = ({ question: e, lang: t = "ru" }) => {
  oe({
    name: "guide_follow_link_chat_click",
    parameters: {
      product_id: (e == null ? void 0 : e.product_id) || null,
      product_name: (e == null ? void 0 : e.product_title) || null,
      question: e == null ? void 0 : e.title,
      question_id: e == null ? void 0 : e.id,
      snippet_code: J,
      snippet_name: Y
    }
  }, t);
}, Pi = ({ link: e, title: t, question: n, lang: s = "ru" }) => {
  oe({
    name: "guide_link_open_click",
    parameters: {
      link_title: t,
      link_url: e,
      product_id: (n == null ? void 0 : n.product_id) || null,
      product_name: (n == null ? void 0 : n.product_title) || null,
      question: n == null ? void 0 : n.title,
      question_id: n == null ? void 0 : n.id,
      snippet_code: J,
      snippet_name: Y
    }
  }, s);
}, Mi = ({ question: e, lang: t = "ru" }) => {
  oe({
    name: "guide_question_link_app_click",
    parameters: {
      product_id: (e == null ? void 0 : e.product_id) || null,
      product_name: (e == null ? void 0 : e.product_title) || null,
      question: e == null ? void 0 : e.title,
      question_id: e == null ? void 0 : e.id,
      snippet_code: J,
      snippet_name: Y
    }
  }, t);
};
var Mn = function(e, t, n) {
  if (!t.hasOwnProperty(n)) {
    var s = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(t, n, s);
  }
};
const xi = { props: { template: String, parent: Object, templateProps: { type: Object, default: function() {
  return {};
} } }, render: function(e) {
  if (this.template) {
    var t = this.parent || this.$parent, n = t.$data;
    n === void 0 && (n = {});
    var s = t.$props;
    s === void 0 && (s = {});
    var o = t.$options;
    o === void 0 && (o = {});
    var i = o.components;
    i === void 0 && (i = {});
    var r = o.computed;
    r === void 0 && (r = {});
    var u = o.methods;
    u === void 0 && (u = {});
    var f = this.$data;
    f === void 0 && (f = {});
    var c = this.$props;
    c === void 0 && (c = {});
    var h = this.$options;
    h === void 0 && (h = {});
    var _ = h.methods;
    _ === void 0 && (_ = {});
    var T = h.computed;
    T === void 0 && (T = {});
    var E = h.components;
    E === void 0 && (E = {});
    var d = { $data: {}, $props: {}, $options: {}, components: {}, computed: {}, methods: {} };
    Object.keys(n).forEach(function(S) {
      f[S] === void 0 && (d.$data[S] = n[S]);
    }), Object.keys(s).forEach(function(S) {
      c[S] === void 0 && (d.$props[S] = s[S]);
    }), Object.keys(u).forEach(function(S) {
      _[S] === void 0 && (d.methods[S] = u[S]);
    }), Object.keys(r).forEach(function(S) {
      T[S] === void 0 && (d.computed[S] = r[S]);
    }), Object.keys(i).forEach(function(S) {
      E[S] === void 0 && (d.components[S] = i[S]);
    });
    var y = Object.keys(d.methods || {}), F = Object.keys(d.$data || {}), I = Object.keys(d.$props || {}), O = Object.keys(this.templateProps), k = F.concat(I).concat(y).concat(O), C = (ce = t, ie = {}, y.forEach(function(S) {
      return Mn(ce, ie, S);
    }), ie), $ = function(S) {
      var Ie = {};
      return S.forEach(function(H) {
        H && Object.getOwnPropertyNames(H).forEach(function(Ee) {
          return Mn(H, Ie, Ee);
        });
      }), Ie;
    }([d.$data, d.$props, C, this.templateProps]);
    return e({ template: this.template || "<div></div>", props: k, computed: d.computed, components: d.components, provide: this.$parent._provided }, { props: $ });
  }
  var ce, ie;
} };
function st(e, t, n, s, o, i, r, u) {
  var f = typeof e == "function" ? e.options : e;
  t && (f.render = t, f.staticRenderFns = n, f._compiled = !0), s && (f.functional = !0), i && (f._scopeId = "data-v-" + i);
  var c;
  if (r ? (c = function(T) {
    T = T || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !T && typeof __VUE_SSR_CONTEXT__ < "u" && (T = __VUE_SSR_CONTEXT__), o && o.call(this, T), T && T._registeredComponents && T._registeredComponents.add(r);
  }, f._ssrRegister = c) : o && (c = u ? function() {
    o.call(
      this,
      (f.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : o), c)
    if (f.functional) {
      f._injectStyles = c;
      var h = f.render;
      f.render = function(E, d) {
        return c.call(d), h(E, d);
      };
    } else {
      var _ = f.beforeCreate;
      f.beforeCreate = _ ? [].concat(_, c) : [c];
    }
  return {
    exports: e,
    options: f
  };
}
const ne = Object.freeze({
  default: "default",
  selectReason: "selectReason",
  comment: "comment",
  end: "end"
}), Fi = {
  name: "snippetItemVote",
  props: {
    questionInfo: {
      type: Object,
      default: () => ({})
    },
    lang: {
      type: String,
      default: "ru"
    }
  },
  data: () => ({
    // Активная страница
    page: ne.default,
    // Типы страниц
    pageType: ne,
    // Негативные причины
    negativeReasons: ["dontLikeHowItWorks", "knowHowImproveAnswer"],
    negativeReason: null,
    // Коментарий
    negativeComment: null
  }),
  computed: {
    // Считают ответ полезным
    findAnswerHelpful() {
      var e;
      return `${se(this.lang, "findAnswerHelpful1")} ${((e = this.questionInfo) == null ? void 0 : e.usefulness.toFixed(2)) * 100 + "%"} ${se(this.lang, "findAnswerHelpful2")}`;
    },
    // Осталось слов
    negativeCommentRemaining() {
      var e;
      return `${((e = this.negativeComment) == null ? void 0 : e.length) || 0}/300`;
    }
  },
  methods: {
    // Проголосовать да
    voteYes() {
      this.page = ne.end, Ot(!0, this.questionInfo, null, null, this.lang), Ct(!0, this.questionInfo, null, null, this.lang), $e({
        question: this.questionInfo,
        eventName: "guide_question_voting_click",
        additionalParams: {
          button: "yes"
        },
        lang: this.lang
      });
    },
    // Проголосовать нет
    voteNo() {
      this.page = ne.selectReason, $e({
        question: this.questionInfo,
        eventName: "guide_question_voting_click",
        additionalParams: {
          button: "no"
        },
        lang: this.lang
      });
    },
    // Выбрать причину
    selectReasonHandle() {
      this.negativeReason === "knowHowImproveAnswer" ? this.page = ne.comment : this.negativeReason === "dontLikeHowItWorks" && (Ot(!1, this.questionInfo, 1, null, this.lang), Ct(!1, this.questionInfo, 1, null, this.lang), this.page = ne.end), $e({
        question: this.questionInfo,
        eventName: "guide_question_voting_reason_select",
        additionalParams: {
          reason: this.negativeReason === "knowHowImproveAnswer" ? "improve_answer" : "don't_like"
        },
        lang: this.lang
      });
    },
    // Ввод комента
    negativeCommentInput(e) {
      e && e.length <= 300 && (this.negativeComment = e);
    },
    // Отправить комент
    sendComment() {
      this.negativeComment && (this.page = ne.end, Ot(!1, this.questionInfo, 2, this.negativeComment, this.lang), Ct(!1, this.questionInfo, 2, this.negativeComment, this.lang), $e({
        question: this.questionInfo,
        eventName: "guide_question_voting_comment_sent",
        additionalParams: {
          reason: this.negativeComment
        },
        lang: this.lang
      }));
    },
    // Сброс
    reset() {
      this.page = ne.default, this.negativeReason = null, this.negativeComment = null;
    },
    // Перевод
    t(e) {
      return se(this.lang, e);
    }
  }
};
var Ui = function() {
  var t = this, n = t._self._c;
  return n("ds-card", { staticClass: "guide-snippets__question-vote-wrapper", attrs: { type: "secondary" } }, [t.page === t.pageType.default ? n("div", { staticClass: "guide-snippets__question-vote guide-snippets__question-vote--default" }, [n("div", { staticClass: "guide-snippets__question-vote-left" }, [n("div", { staticClass: "guide-snippets__question-vote-usefulness" }, [t._v(t._s(t.findAnswerHelpful))]), n("div", { staticClass: "guide-snippets__question-vote-question" }, [t._v(t._s(t.t("wasAnswerHelpful")))])]), n("div", { staticClass: "guide-snippets__question-vote-right" }, [n("ds-button", { staticClass: "guide-snippets__question-vote-button", attrs: { type: "outline", size: "small" }, on: { click: function(s) {
    return t.voteYes();
  } } }, [t._v(t._s(t.t("yes")))]), n("ds-button", { staticClass: "guide-snippets__question-vote-button", attrs: { type: "outline", size: "small" }, on: { click: function(s) {
    return t.voteNo();
  } } }, [t._v(t._s(t.t("no")))])], 1)]) : t.page === t.pageType.selectReason ? n("div", { staticClass: "guide-snippets__question-vote guide-snippets__question-vote--select-reason" }, [n("strong", [t._v(t._s(t.t("pleaseIndicateReason")))]), n("div", { staticClass: "guide-snippets__question-vote-negative-reasons" }, t._l(t.negativeReasons, function(s) {
    return n("div", { key: s, staticClass: "guide-snippets__question-vote-negative-reason", class: { selected: t.negativeReason === s }, on: { click: function(o) {
      t.negativeReason = s;
    } } }, [t._v(t._s(t.t(s)))]);
  }), 0), n("div", { staticClass: "guide-snippets__question-vote-actions" }, [n("ds-button", { staticClass: "guide-snippets__question-vote-negative-reason-send", attrs: { type: "outline", size: "small" }, on: { click: function(s) {
    return t.selectReasonHandle();
  } } }, [t._v(t._s(t.t("send")))])], 1)]) : t.page === t.pageType.comment ? n("div", { staticClass: "guide-snippets__question-vote guide-snippets__question-vote--comment" }, [n("div", { staticClass: "guide-snippets__question-vote-comment-wrapper" }, [n("textarea", { staticClass: "guide-snippets__question-vote-comment", attrs: { maxlength: "300", placeholder: t.t("describeSuggestionImproveAnswer") }, domProps: { value: t.negativeComment }, on: { input: function(s) {
    return t.negativeCommentInput(s.target.value);
  } } }), t._v(" "), n("div", { staticClass: "guide-snippets__question-vote-comment-remaining" }, [t._v(t._s(t.negativeCommentRemaining))])]), n("div", { staticClass: "guide-snippets__question-vote-actions" }, [n("ds-button", { staticClass: "guide-snippets__question-vote-negative-reason-send", attrs: { type: "outline", size: "small" }, on: { click: function(s) {
    return t.sendComment();
  } } }, [t._v(t._s(t.t("send")))]), n("ds-button", { staticClass: "guide-snippets__question-vote-negative-reason-send", attrs: { type: "outline", size: "small" }, on: { click: function(s) {
    return t.reset();
  } } }, [t._v(t._s(t.t("cancel")))])], 1)]) : t.page === t.pageType.end ? n("div", { staticClass: "guide-snippets__question-vote guide-snippets__question-vote--end" }, [n("div", { staticClass: "guide-snippets__question-vote-thank" }, [t._v(t._s(t.t("thanksForFeedback")))])]) : t._e()]);
}, Hi = [], zi = /* @__PURE__ */ st(
  Fi,
  Ui,
  Hi,
  !1,
  null,
  null,
  null,
  null
);
const $i = zi.exports;
function Bi(e, { MainHost: t }) {
  let n = e;
  return n = n.replaceAll("http://kaspi.kz", "https://kaspi.kz"), n = n.replaceAll('href="/', `href="${t}/`), n;
}
function ji(e, { CdnUrl: t }) {
  let n = e, s = e.match(/src="([^"]*)/g);
  if (!s)
    return e;
  for (let o = 0; o < s.length; o++) {
    let i = s[o], r = i.replace("/guide/_uploads", t + "content/kkz");
    n = n.replace(i, r);
  }
  return n;
}
function Gi(e, { isMobApp: t, CdnUrl: n, MainHost: s, getTranslation: o, isLinkToDocument: i, isIgnoreDocLogQueryRequired: r, isLinkWithQrCase: u, isIos: f }) {
  let c = e;
  const h = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"(?:[^>]*?\s+)?(?:target="([^"]*)")?\s*>(.*?)<\/a>/gi;
  let _;
  for (; (_ = h.exec(e)) !== null; ) {
    const d = _[0], y = _[1];
    let F = _[3] ? _[3].replace(/<[^>]*>/g, "") : "";
    const I = `href="${y}"`;
    let O = I;
    if (y.indexOf("guide/_uploads") !== -1) {
      let C = y.split("guide/_uploads")[1], $ = `${n}content/kkz${C}`;
      f && ($ += `?sa-filename=${encodeURI(C.split("Document/")[1] || C.split("document/")[1])}`), O = `href="${$}"`, $.indexOf("files/Document") !== -1 && (O = `href="${$}" @click="documentLinkClick"`);
    } else if (i(y)) {
      const C = r(y) ? "?ignoreDownloadLog=true" : "";
      O = `href="${y}${C}" @click="documentLinkClick"`;
    } else if (!t && u(y)) {
      let C = y.split(s)[1].split("/"), $ = C[0], ce = C[1], ie = C[2];
      if (!$) {
        var T = null, E = null;
        switch (ce) {
          case "maps": {
            T = o("mapsTitle"), E = "content_maps.svg";
            break;
          }
          case "bank":
            if (ie === "esignhistory") {
              T = o("bankHistoryTitle"), E = "content_bank_history.svg";
              break;
            }
          case "red":
          case "bonus":
            T = o("bankTitle"), E = "content_bank.svg";
            break;
          case "pay":
          case "payment":
            T = o("paymentTitle"), E = "content_payment.svg";
            break;
        }
        T && E && (O = `@click="openModal('${T}','${E}')"`);
      }
    } else
      O = `href="${y}" @click="openExternalLink({link: '${y}', title: '${F}'})"`;
    const k = d.replace(I, O);
    c = c.replace(d, k);
  }
  return c;
}
const xn = ["maps", "bank", "red", "bonus", "pay", "payment"], Wi = ({ link: e, guideHost: t, payHost: n, cdnUrl: s }) => {
  const o = Re({ link: e, start: t }) || Re({ link: e, start: n }) || Re({ link: e, start: s }), i = e.includes("files/Document") || e.includes("/documents/");
  return o && i;
}, qi = ({ link: e, guideHost: t }) => e.includes("/documents/") && Re({ link: e, start: t }), Vi = ({ link: e, mainHost: t }) => {
  for (let n = 0; n < xn.length; n++) {
    const s = t + "/" + xn[n];
    if (Re({ link: e, start: s }))
      return !0;
  }
  return !1;
}, Re = ({ link: e, start: t }) => e.startsWith(t), Ki = (e, t) => ({
  /* Язык */
  lang: e,
  /* Ссылка на CDN */
  CdnUrl: t.CdnUrl,
  /* Основной адрес */
  MainHost: t.MainHost,
  /* Хост для чата */
  ChatHost: t.ChatHost,
  /* Хост гида */
  GuideHost: t.GuideHost,
  /* Хост Pay */
  PayHost: t.PayHost,
  GuideSnippetApiUrl: t.GuideSnippetApiUrl,
  /* Адрес конструктора форм */
  FormHost: t.FormHost,
  /* Мобильное приложение ? */
  isMobApp: t.hasOwnProperty("isMobApp") ? t.isMobApp : os(),
  /* Телефон ? */
  isMobile: t.hasOwnProperty("isMobile") ? t.isMobile : ss(),
  /* ios ? */
  isIos: t.hasOwnProperty("isIos") ? t.isIos : Gt(),
  /* android ? */
  isAndroid: t.hasOwnProperty("isAndroid") ? t.isAndroid : Ko(),
  /* Получить перевод по ключу */
  getTranslation: Oi(e),
  isLinkToDocument: (n) => Wi({ link: n, guideHost: t.GuideHost, payHost: t.PayHost, cdnUrl: t.CdnUrl }),
  isIgnoreDocLogQueryRequired: (n) => qi({ link: n, guideHost: t.GuideHost }),
  isLinkWithQrCase: (n) => Vi({ link: n, mainHost: t.MainHost })
}), Lt = {
  задать_вопрос: (e) => ({
    host: e.ChatHost,
    url: "/chat",
    query: "&threadId=chatGuide",
    isLangRequired: !1,
    placeholderDesktop: e.getTranslation("askFormTitle"),
    placeholderMobile: e.getTranslation("guideChatTitle"),
    modalTitle: e.getTranslation("openGuideChatTitle"),
    modalQR: "ask_form.png",
    // перейдет в form/ask и редирекнет в чат если сидим на kkz, для pay откроется форма
    modalDescription: e.getTranslation("scanToGoApp")
  }),
  добавить_услугу: (e) => ({
    url: "/form/new_service",
    base: "/guide"
  }),
  снятие_банкомат: (e) => ({
    host: e.FormHost,
    url: "/form/withdrawalform",
    query: "&postScreen=true",
    base: "",
    modalTitle: e.getTranslation("fillFormInApp"),
    modalQR: "withdraw_form.png",
    modalDescription: e.getTranslation("scanToGoApp")
  }),
  снятие_банкомат_пэй: (e) => ({
    url: "/form/withdraw",
    base: "/guide"
  }),
  оплата_картой: (e) => ({
    host: e.FormHost,
    url: "/form/cardform",
    query: "&postScreen=true",
    base: "",
    modalTitle: e.getTranslation("fillFormInApp"),
    modalQR: "card_form.png",
    modalDescription: e.getTranslation("scanToGoApp")
  }),
  деньги_не_поступили: (e) => ({
    host: e.FormHost,
    url: "/form/cashinform",
    query: "&postScreen=true",
    base: "",
    modalTitle: e.getTranslation("fillFormInApp"),
    modalQR: "cash-in_form.png",
    modalDescription: e.getTranslation("scanToGoApp")
  }),
  деньги_не_поступили_пэй: (e) => ({
    url: "/form/replenishment",
    base: "/guide"
  }),
  звонки_банк: (e) => ({
    host: e.FormHost,
    url: "/form/CallDeclineForm",
    query: "&postScreen=true",
    base: "",
    modalTitle: e.getTranslation("fillFormInApp"),
    modalQR: "calls_form.png",
    modalDescription: e.getTranslation("scanToGoApp")
  }),
  свидетельство_о_смерти: (e) => ({
    host: e.FormHost,
    url: "/form/DeathCertificateForm",
    query: "&postScreen=true",
    base: ""
  }),
  мошенники: (e) => ({
    host: e.FormHost,
    url: "/form/FraudForm",
    query: "&postScreen=true",
    base: "",
    modalTitle: e.getTranslation("fillFormInApp"),
    modalQR: "fraud_form.png",
    modalDescription: e.getTranslation("scanToGoApp")
  }),
  отмена_перевода: (e) => ({
    url: "/form/cancel_transaction",
    base: "/guide",
    modalTitle: e.getTranslation("fillFormInApp"),
    modalQR: "cancel-transaction_form.png",
    modalDescription: e.getTranslation("scanToGoApp")
  }),
  оптимизация_кредита: (e) => ({
    url: "/form/optimization",
    base: "/guide",
    modalTitle: e.getTranslation("fillFormInApp"),
    modalQR: "optimization_form.png",
    modalDescription: e.getTranslation("scanToGoApp")
  })
}, Ji = (e, t, n, s) => ot(e, t, n, s, "задать_вопрос"), Yi = (e, t, n, s) => {
  const o = t[0];
  if (s.isMobile) {
    if (s.isIos)
      return `<a href='http://appsto.re/kz/zU2ohb.i'
                    target='_blank' 
                    @click="appLinkClickHandle">${o}</a>`;
    if (s.isAndroid)
      return `<a href='https://play.google.com/store/apps/details?id=kz.kaspi.mobile'
                    target='_blank'
                    @click="appLinkClickHandle">${o}</a>`;
  } else
    return `<a @click="openModal('${t[1] || s.getTranslation("scanToGoApp")}', 'mobapp_link.svg')">${o}</a>`;
  return o;
}, ot = (e, t, n, s, o = t[0]) => {
  var u;
  const i = (u = Lt[o]) == null ? void 0 : u.call(Lt, s);
  if (!i)
    return "";
  const r = (s.isMobApp ? i.placeholderMobile : i.placeholderDesktop) || s.getTranslation("formText");
  if (s.isMobApp || !i.modalQR) {
    const f = s.isMobApp ? "mobile-app-form" : "", c = i.host || s.MainHost, h = i.base || "";
    let _ = !0;
    "isLangRequired" in i && (_ = i.isLangRequired);
    const T = _ ? `/${s.lang}` : "", E = (n || "?") + (i.query || "");
    return `<br/><a class="${f}" @click="openLink('${c + h + T + i.url + E}', 'Переход по ссылке')">${r}</a>`;
  }
  return `<a class="snippet_placeholder" @click="openModal('${i.modalTitle}', '${i.modalQR}', '${i.modalDescription}')">${r}</a>`;
}, Fn = {
  без_моего_участия: "without_participation",
  не_устраивает_товар: "does_not_like_product",
  деньги_списаны_несколько_раз: "money_withdrawed_many_times",
  покупка_не_прошла: "withdrawed_failded",
  покупка_возвращена: "purchase_returned"
}, Qi = (e, t, n, s) => {
  let o = "";
  const i = (t[t.length - 1] || "").replace(/\s+/g, "");
  return i && Fn[i] && (o = "&insert-purchase-returnmoneyreason=" + Fn[i]), ot(e, ["оплата_картой", ...t], n + o, s, "оплата_картой");
}, Xi = (e, t, n, s) => ot(e, ["задать_вопрос", ...t], n, s, "задать_вопрос"), Zi = (e, t, n, s) => s.isMobApp ? `<a href='https://kaspi.kz/bank/esignature/process?businessProcess=EDIT_CLIENT_DATA&referer=ecd'>${t[0]}</a>` : `<a @click="openModal('Сканируйте, чтобы перейти в приложение Kaspi.kz', 'data_changes.png')">${t[0]}</a>`, er = (e, t) => {
  const n = new XMLHttpRequest();
  n.open("GET", t.GuideSnippetApiUrl + "/video/" + t.lang + "/" + e), n.addEventListener("readystatechange", function() {
    if (n.readyState === 4) {
      var s = JSON.parse(n.response), o = t.CdnUrl + "content/kkz/", i = "";
      t.isMobile ? i = s.body.local_mobile_url : i = s.body.localUrl, i.startsWith("/video") || (i = "video/" + i);
      var r = document.getElementById(`video-${e}`);
      r && (r.src = o + i);
    }
  }), n.send();
}, tr = (e, t, n, s) => {
  const o = t[0];
  return setTimeout(() => er(o, s), 100), `<video controls="controls" id="video-${o}" @play="watchPlay(${o})" @ended="fullVideo(${o})"></video>`;
}, nr = {
  скачать_эцп: Ji,
  ссылка_приложения: Yi,
  форма: ot,
  вернуть_деньги: Qi,
  остались_вопросы: Xi,
  изменение_данных: Zi,
  видео: tr
}, It = /%.*?[_|\s](.*?)\((.*?)\)%/g;
function sr(e, t = {}, n = {}) {
  let s = e.match(It);
  if (!s)
    return e;
  let o = e;
  for (let i = 0; i < s.length; i++) {
    let r = It.exec(s[i]);
    if (r || (r = It.exec(s[i])), !r || r && r.length < 2)
      continue;
    let u = r[1].replace(/\s+/g, ""), f = r.length >= 3 ? r[2].split(",") : [], c = [];
    for (let T in t)
      t.hasOwnProperty(T) && c.push(encodeURIComponent(T) + "=" + encodeURIComponent(t[T]));
    let h = "?" + c.join("&"), _ = nr[u];
    _ ? o = o.replaceAll(s[i], _(u, f, h, n)) : o = o.replaceAll(s[i], "");
  }
  return o;
}
function or(e, t) {
  let n = e;
  return (n.match(/<div class="spoiler-title">/g) || []).forEach((o, i) => {
    const r = n.match(/<div class="spoiler-content"[^>]*>/), u = n.match(/<div class=".*?spoiler-toggle.*?"[^>]*>/);
    n = n.replace(o, `<div class="spoiler-title" id="spoiler_title_${i + 1}" @click="toggleSpoiler(${i + 1})">`).replace(r, `<div id="spoiler_content_${i + 1}" class="spoiler-content">`).replace(u, `<div id="spoiler_toggle_${i + 1}" class="spoiler-toggle hide-icon" >`);
  }), n;
}
const ge = Object.freeze({
  CdnUrl: "https://guide.kaspi.kz/cdn/",
  MainHost: "https://kaspi.kz",
  GuideHost: "https://guide.kaspi.kz",
  ChatHost: "https://kaspi.kz",
  PayHost: "https://pay.kaspi.kz",
  GuideSnippetApiUrl: "https://guide.kaspi.kz/snippet/api/v1",
  FormHost: "https://form.kaspi.kz"
}), ir = Object.freeze({
  CdnUrl: "https://guide.kaspi.kz/cdn/",
  MainHost: "https://preprod.kaspi.kz",
  GuideHost: "https://guide-preprod.kaspi.kz",
  ChatHost: "https://kaspi.kz",
  PayHost: "https://pay.kaspi.kz",
  GuideSnippetApiUrl: "https://guide-test.kaspi.kz/snippet/api/v1",
  FormHost: "https://form-front-preprod.kaspi.kz"
}), rr = Object.freeze({
  CdnUrl: "https://guide.kaspi.kz/cdn/",
  MainHost: "https://test.kaspi.kz",
  GuideHost: "https://guide-test.kaspi.kz",
  ChatHost: "https://kaspi.kz",
  PayHost: "https://pay.kaspi.kz",
  GuideSnippetApiUrl: "https://guide-test.kaspi.kz/snippet/api/v1",
  FormHost: "https://form-front-test.kaspi.kz"
}), fs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  preprod: ir,
  prod: ge,
  test: rr
}, Symbol.toStringTag, { value: "Module" }));
function ar(e, t, n = ge) {
  const s = Ki(t, n);
  let o = e;
  return o = Bi(o, s), o = ji(o, s), o = Gi(o, s), o = sr(o, {}, s), o = or(o), `<div class="guide-snippets__question-content">${o}</div>`;
}
const lr = {
  name: "snippetItemShare",
  props: {
    lang: {
      type: String,
      default: "ru"
    },
    questionInfo: {
      type: Object,
      default: () => ({})
    },
    // Контур для использования
    contour: {
      type: String,
      default: "prod",
      validator: (e) => ["prod", "preprod", "test"].includes(e)
    }
  },
  computed: {
    isIos() {
      return Gt();
    },
    shareLabel() {
      return se(this.lang, "share");
    },
    guideHost() {
      const e = fs[this.contour];
      return e ? e.GuideHost : "https://guide.kaspi.kz";
    }
  },
  methods: {
    // Поделиться
    shareHandle() {
      let e = `${this.guideHost}/client/${this.lang}/${this.questionInfo.product_code}/${this.questionInfo.theme_code}`;
      this.questionInfo.sub_theme_code && (e += `/${this.questionInfo.sub_theme_code}`), e += `/q${this.questionInfo.id}`, window.mobapp && window.mobapp.sharePage ? window.mobapp.sharePage(e) : window.userDelete ? window.userDelete.send("sharePage", JSON.stringify({ url: e })) : window.auth && window.auth.send("sharePage", JSON.stringify({ url: e }));
    }
  }
};
var cr = function() {
  var t = this, n = t._self._c;
  return n("div", { staticClass: "guide-snippets__share", on: { click: function(s) {
    return t.shareHandle();
  } } }, [t.isIos ? n("ds-icon", { staticClass: "guide-snippets__share-icon", attrs: { name: "system/share-ios-500", color: "currentColor" } }) : n("ds-icon", { staticClass: "guide-snippets__share-icon", attrs: { name: "system/share-android-500", color: "currentColor" } }), n("div", { staticClass: "guide-snippets__share-text" }, [t._v(t._s(t.shareLabel))])], 1);
}, ur = [], pr = /* @__PURE__ */ st(
  lr,
  cr,
  ur,
  !1,
  null,
  null,
  null,
  null
);
const dr = pr.exports, fr = {
  name: "snippetItemContent",
  components: { VRuntimeTemplate: xi, snippetItemVote: $i, snippetItemShare: dr },
  props: {
    questionInfo: {
      type: Object,
      default: () => ({})
    },
    open: {
      type: Boolean
    },
    lang: {
      type: String,
      default: "ru"
    },
    config: {
      type: Object,
      default: () => ({})
    },
    // Контур для использования
    contour: {
      type: String,
      default: "prod",
      validator: (e) => ["prod", "preprod", "test"].includes(e)
    }
  },
  data: () => ({
    preparedContent: null
  }),
  computed: {
    // Контент вопроса
    content() {
      var e;
      return ((e = this.questionInfo) == null ? void 0 : e.content) || "";
    },
    // Заголовок обновлен ...
    updatedTitle() {
      return `${se(this.lang, "updated")} ${this.questionInfo.updatedDate}`;
    }
  },
  methods: {
    // Откыть модалку
    openModal(e, t) {
      console.log("open modal", e, t);
    },
    // Открыть ссылку
    openLink(e, t, n = !1) {
      const s = n ? "_blank" : "_self", o = this.questionInfo;
      e.includes("kaspi.kz/chat") && Ni({
        question: o,
        lang: this.lang
      }), Ii({
        link: e,
        title: t,
        question: o,
        lang: this.lang
      }), window.open(e, s);
    },
    /**
     * Записываем в aws событие клика по внешней ссылке
     * @param {string} link - ссылка для последующего открытия
     * @param {string} title - текст, на котором висела ссылка
     */
    openExternalLink({ link: e, title: t }) {
      Pi({
        link: e,
        title: t,
        question: this.questionInfo,
        lang: this.lang
      });
    },
    /**
     * Записываем в aws событие клика по ссылке приложения
     */
    appLinkClickHandle() {
      Mi({
        question: this.questionInfo,
        lang: this.lang
      });
    },
    /**
     * Записываем событие открытия документа в aws, затем открываем по переданной ссылке
     */
    documentLinkClick() {
      Di({
        question: this.questionInfo,
        lang: this.lang
      });
    },
    /**
     * Смотрим за проигрывателем видео, чтобы зафиксировать когда пользователь был в начале,
     * т.е. либо первый раз включил видео, либо прокрутил в начало и начал смотреть заново
     * @param {number} videoId - id видео
     */
    watchPlay(e) {
      const t = document.getElementById(`video-${e}`);
      (t == null ? void 0 : t.currentTime) <= 0.01 && Pn({
        eventFlag: "start",
        videoId: e,
        videoSrc: t == null ? void 0 : t.src,
        question: this.questionInfo,
        lang: this.lang
      });
    },
    // событие срабатывает, когда пользователь просмотрел видео
    fullVideo(e) {
      const t = document.getElementById(`video-${e}`);
      Pn({
        eventFlag: "end",
        videoId: e,
        videoSrc: t == null ? void 0 : t.src,
        question: this.questionInfo,
        lang: this.lang
      });
    },
    // Открыть/закрыть спойлер
    toggleSpoiler(e) {
      var s, o;
      const t = document.getElementById("spoiler_content_" + e), n = document.getElementById("spoiler_toggle_" + e);
      n.classList.contains("show-icon") ? ((o = t == null ? void 0 : t.classList) == null || o.remove("show"), n.classList.add("hide-icon"), n.classList.remove("show-icon")) : ((s = t == null ? void 0 : t.classList) == null || s.add("show"), n.classList.remove("hide-icon"), n.classList.add("show-icon"));
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.preparedContent = ar(this.content, this.lang, this.config);
    });
  }
};
var mr = function() {
  var t = this, n = t._self._c;
  return n("div", [t.preparedContent ? n("v-runtime-template", { attrs: { template: t.preparedContent } }) : t._e(), n("div", { staticClass: "guide-snippets__question-content-update" }, [t._v(t._s(t.updatedTitle))]), n("snippet-item-share", { attrs: { "question-info": t.questionInfo, lang: t.lang, contour: t.contour } }), t.open ? n("snippet-item-vote", { attrs: { "question-info": t.questionInfo, lang: t.lang } }) : t._e()], 1);
}, hr = [], _r = /* @__PURE__ */ st(
  fr,
  mr,
  hr,
  !1,
  null,
  null,
  null,
  null
);
const gr = _r.exports;
const yr = {
  name: "snippet",
  components: { SnippetItemContent: gr },
  props: {
    // Заголовок
    title: {
      type: String,
      default: null
    },
    // Код вставки
    code: {
      type: String
    },
    // Язык вставки (ru или kz)
    lang: {
      type: String,
      default: "ru",
      validator: (e) => ["ru", "kz"].includes(e)
    },
    // Ставить ли ссылку на гид
    guideLink: {
      type: Boolean,
      default: !1
    },
    // Огруленные острова
    rounded: {
      type: Boolean,
      default: !1
    },
    // Контур для использования
    contour: {
      type: String,
      default: "prod",
      validator: (e) => ["prod", "preprod", "test"].includes(e)
    },
    // Конфиг (если есть необходимость переписать какое то поле в конфиге)
    selfConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    // Данные вставки
    snippetData: null,
    // Токен для аналитики
    userToken: null,
    config: ge,
    // Таймаут скролла
    scrollTimeout: null,
    // Индекс открытого вопроса
    openIndex: null
  }),
  computed: {
    // Телефон ?
    isMobile() {
      return ss();
    },
    // Мобильное приложение
    isMobileApp() {
      return os();
    },
    // Список вопросов
    questions() {
      var e;
      return ((e = this.snippetData) == null ? void 0 : e.questions) || [];
    },
    // Значение верхнего радиуса
    radiusValue() {
      return this.rounded ? "rounded" : "default";
    }
  },
  methods: {
    // Перейти в гид
    goGuide() {
      var t;
      let e = (t = this.snippetData) == null ? void 0 : t.link_url;
      e = e.replace(ge.MainHost, ""), e = e.replace(ge.GuideHost, ""), e = e.replace(ge.PayHost, ""), e.startsWith("/guide") && (e = e.replace("/guide", "/client")), window.open(this.config.GuideHost + e);
    },
    // На открытие контента
    onOpen(e) {
      this.openIndex = e - 1, e && (Li(
        {
          question: this.questions[this.openIndex],
          lang: this.lang,
          count: this.questions.length,
          position: e
        }
      ), clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(() => this.scrollTo(this.openIndex), 400));
    },
    // Скролл к открытому элементу
    scrollTo(e) {
      var n, s, o;
      const t = (o = (s = (n = this.$refs["content-item"][e]) == null ? void 0 : n.$el) == null ? void 0 : s.getBoundingClientRect()) == null ? void 0 : o.top;
      t && (window != null && window.scrollTo) && window.scrollTo({ behavior: "smooth", top: t + window.pageYOffset - 100 });
    }
  },
  async mounted() {
    var e;
    this.config = { ...fs[this.contour], ...this.selfConfig }, Ei(this.config.GuideSnippetApiUrl), this.userToken = await bi(), this.snippetData = await Ai(this.code, this.lang), Ci(this.code, (e = this.snippetData) == null ? void 0 : e.name, this.lang);
  }
};
var Tr = function() {
  var t = this, n = t._self._c;
  return t.snippetData ? n("div", { staticClass: "guide-snippets", class: [
    { "guide-snippets--mobile-app": t.isMobileApp },
    { "guide-snippets--browser": !t.isMobileApp },
    { "guide-snippets--mobile": t.isMobile },
    { "guide-snippets--desktop": !t.isMobile }
  ] }, [n("ds-island", { staticClass: "guide-snippets__island", attrs: { "radius-top": t.radiusValue } }, [t.title ? n("ds-title", { staticClass: "guide-snippets__title", attrs: { size: "h2" } }, [t._v(t._s(t.title))]) : t._e(), n("ds-accordion", { on: { input: function(s) {
    return t.onOpen(s);
  } } }, t._l(t.questions, function(s, o) {
    return n("ds-expand", { key: s.id, ref: "content-item", refInFor: !0, attrs: { title: s.title }, scopedSlots: t._u([{ key: "title", fn: function() {
      return [t._v(t._s(s.title))];
    }, proxy: !0 }], null, !0) }, [n("snippet-item-content", { attrs: { open: t.openIndex === o, "question-info": s, config: t.config, lang: t.lang, contour: t.contour } })], 1);
  }), 1)], 1), t.guideLink && t.snippetData ? n("ds-island", { staticClass: "guide-snippets__island" }, [n("ds-cell", { nativeOn: { click: function(s) {
    return t.goGuide();
  } }, scopedSlots: t._u([{ key: "left", fn: function() {
    return [n("div", { staticClass: "guide-snippets__link-icon-wrapper" }, [n("ds-icon", { attrs: { name: "system/kaspi-guide-logo-500", color: "icon-brand" } })], 1)];
  }, proxy: !0 }, { key: "default", fn: function() {
    return [n("div", { staticClass: "guide-snippets__link-content" }, [n("div", { staticClass: "guide-snippets__link-title body-500" }, [t._v("Kaspi Гид")]), n("div", { staticClass: "guide-snippets__link-text caption-500" }, [t._v(t._s(t.snippetData.link_text))])])];
  }, proxy: !0 }, { key: "right", fn: function() {
    return [n("div", { staticClass: "guide-snippets__link-arrow-wrapper" }, [n("ds-icon", { attrs: { name: "system/chevron-right-400", color: "icon-light" } })], 1)];
  }, proxy: !0 }], null, !1, 3974772815) })], 1) : t._e()], 1) : t._e();
}, Er = [], Ar = /* @__PURE__ */ st(
  yr,
  Tr,
  Er,
  !1,
  null,
  null,
  null,
  null
);
const wr = Ar.exports;
export {
  ar as contentHandling,
  wr as snippet
};
